webpackJsonp([1],Array(184).concat([
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_company_new_vue__ = __webpack_require__(788);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750e311e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_company_new_vue__ = __webpack_require__(934);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_company_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750e311e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_company_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(566));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),
/* 559 */,
/* 560 */,
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(565));

var _alphaNum = _interopRequireDefault(__webpack_require__(568));

var _numeric = _interopRequireDefault(__webpack_require__(569));

var _between = _interopRequireDefault(__webpack_require__(570));

var _email = _interopRequireDefault(__webpack_require__(571));

var _ipAddress = _interopRequireDefault(__webpack_require__(572));

var _macAddress = _interopRequireDefault(__webpack_require__(573));

var _maxLength = _interopRequireDefault(__webpack_require__(574));

var _minLength = _interopRequireDefault(__webpack_require__(575));

var _required = _interopRequireDefault(__webpack_require__(576));

var _requiredIf = _interopRequireDefault(__webpack_require__(577));

var _requiredUnless = _interopRequireDefault(__webpack_require__(578));

var _sameAs = _interopRequireDefault(__webpack_require__(579));

var _url = _interopRequireDefault(__webpack_require__(580));

var _or = _interopRequireDefault(__webpack_require__(581));

var _and = _interopRequireDefault(__webpack_require__(582));

var _not = _interopRequireDefault(__webpack_require__(583));

var _minValue = _interopRequireDefault(__webpack_require__(584));

var _maxValue = _interopRequireDefault(__webpack_require__(585));

var _integer = _interopRequireDefault(__webpack_require__(586));

var _decimal = _interopRequireDefault(__webpack_require__(587));

var helpers = _interopRequireWildcard(__webpack_require__(558));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'ACL001',"APP_NAME":'"ACL"',"QUIPU_URL":'https://ec-motor.makipos.la',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://ec-acl.makipos.la/api',"SALES_URL":'https://ec-sales.makipos.la',"STORAGE_USER_KEY":"acl","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl',"COMPANY_LOGIN_TITLE":'ACL',"COMPANY_LOGIN_BACKGROUND":'https://maki-acl.s3.amazonaws.com/ACL/fenix.png',"ACCEPT_SERVICE_V2":'application/vnd.apiacl.v2+json'}).BUILD === 'web' ? __webpack_require__(567).withParams : __webpack_require__(165).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(558);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(167);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_six_four__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_six_four___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_six_four__);



var getFile = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fileInfo) {
		var _this = this;

		var newFile, words, lastItem, extension, _ref2, response, newImage;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.isLoadingImage = true;
						newFile = {
							name: fileInfo.name.replace(/\s/g, '-'),
							type: fileInfo.type,
							image: fileInfo.sixFour
						};
						_context.prev = 2;
						words = newFile.name.split('.');
						lastItem = words.length;
						extension = words[lastItem - 1];

						if (!(this.allowedFiles.indexOf(extension) > -1)) {
							_context.next = 14;
							break;
						}

						_context.next = 9;
						return this.$http.post('image/one-upload', newFile);

					case 9:
						_ref2 = _context.sent;
						response = _ref2.data;

						if (extension === 'pdf') {
							this.$emit('send-file', { file: response.data.url_image });
							this.isLoadingImage = false;
						} else {
							newImage = new Image();

							newImage.onload = function () {
								if (newImage.naturalWidth <= _this.allowedMaxSize) {
									var model = {
										urlImage: response.data.url_image
									};
									if (_this.itemUpdate) {
										model.item = _this.itemUpdate;
									}
									_this.$emit('send-image', model);
									_this.isLoadingImage = false;
								} else {
									_this.showNotification('El tama\xF1o m\xE1ximo permitido es ' + _this.allowedMaxSize + ' x ' + _this.allowedMaxSize, 'warning');
									_this.isLoadingImage = false;
								}
							};
							newImage.src = response.data.url_image;
						}
						_context.next = 15;
						break;

					case 14:
						this.showNotification('Archivo no v\xE1lido, solo se permite ' + this.allowedFiles.join(','), 'warning');

					case 15:
						_context.next = 20;
						break;

					case 17:
						_context.prev = 17;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 20:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 17]]);
	}));

	return function getFile(_x) {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function actionUploadImage() {
	this.$refs[this.labelRef].click();
}

function data() {
	return {
		allowedFiles: ['jpg', 'jpeg', 'png', 'svg', 'pdf'],
		allowedMaxSize: 25,
		isLoadingImage: false,
		newImage: ''
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'upload-image',
	components: {
		VueSixFour: __WEBPACK_IMPORTED_MODULE_2_vue_six_four___default.a
	},
	data: data,
	methods: {
		actionUploadImage: actionUploadImage,
		getFile: getFile
	},
	props: {
		buttonTitle: {
			default: 'Cambiar de icono',
			type: String
		},
		inputId: {
			type: [Number, String]
		},
		itemUpdate: {
			type: Object,
			default: function _default() {}
		},
		labelFor: {
			type: [Number, String]
		},
		labelRef: {
			type: [Number, String]
		}
	}
});

/***/ }),
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),o=n(5),i=n(2),l=i(r.a,o.a,!1,null,null,null);t.default=l.exports},function(e,t){e.exports=function(e,t,n,r,o,i){var l,u=e=e||{},s=typeof e.default;"object"!==s&&"function"!==s||(l=e,u=e.default);var a="function"==typeof u?u.options:u;t&&(a.render=t.render,a.staticRenderFns=t.staticRenderFns,a._compiled=!0),n&&(a.functional=!0),o&&(a._scopeId=o);var c;if(i?(c=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i)},a._ssrRegister=c):r&&(c=r),c){var f=a.functional,p=f?a.render:a.beforeCreate;f?(a._injectStyles=c,a.render=function(e,t){return c.call(t),p(e,t)}):a.beforeCreate=p?[].concat(p,c):[c]}return{esModule:l,exports:u,options:a}}},function(e,t,n){"use strict";function r(){return{multipleFiles:[]}}function o(e){for(var t=this,n=e.target.files,r=n.length,o=0;o<r;o+=1)(function(e){var o=n[e],i=new FileReader;i.readAsDataURL(o),i.addEventListener("load",function(){var e=l()(o,{sixFour:i.result});t.multipleFiles.push(e),r===t.multipleFiles.length&&(t.$emit("vue-six-four",t.allowMultiple?t.multipleFiles:t.multipleFiles[0]),t.multipleFiles=[]),i=null})})(o)}var i=n(4),l=n.n(i);t.a={data:r,name:"vue-six-four",methods:{readFile:o},props:{allowMultiple:{type:Boolean,default:!1}}}},function(e,t){e.exports=__webpack_require__(56)},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{attrs:{type:"file",multiple:e.allowMultiple},on:{change:e.readFile}})},o=[],i={render:r,staticRenderFns:o};t.a=i}]);

/***/ }),
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_image_vue__ = __webpack_require__(595);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3bdc05e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_image_vue__ = __webpack_require__(608);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_image_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3bdc05e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{ref:_vm.labelRef,attrs:{"for":_vm.labelFor}},[_c('vue-six-four',{attrs:{"id":_vm.inputId,"hidden":""},on:{"vue-six-four":_vm.getFile}}),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"primary"},on:{"click":_vm.actionUploadImage}},[_vm._v("\n\t\t\t"+_vm._s(_vm.buttonTitle)+"\n\t\t")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var getDaysInMonth = __webpack_require__(615)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),
/* 614 */,
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(609)

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var differenceInCalendarMonths = __webpack_require__(635)
var compareAsc = __webpack_require__(611)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(613)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(171)

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),
/* 622 */,
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(624);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(625), __esModule: true };

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(626);
var $Object = __webpack_require__(5).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(14);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(18), 'Object', { defineProperty: __webpack_require__(16).f });


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(610)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(88)
var setISOYear = __webpack_require__(629)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var startOfISOYear = __webpack_require__(168)
var differenceInCalendarDays = __webpack_require__(170)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(610)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(612)

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(610)

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(612)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(88)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var differenceInCalendarDays = __webpack_require__(170)
var compareAsc = __webpack_require__(611)

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var addISOYears = __webpack_require__(628)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(617)
var parse = __webpack_require__(17)
var differenceInSeconds = __webpack_require__(619)
var differenceInMonths = __webpack_require__(618)
var enLocale = __webpack_require__(175)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var startOfHour = __webpack_require__(646)

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(621)

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(168)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var startOfMinute = __webpack_require__(650)

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var startOfQuarter = __webpack_require__(653)

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var startOfSecond = __webpack_require__(655)

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var getDaysInMonth = __webpack_require__(615)

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),
/* 659 */,
/* 660 */,
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADDITIONAL_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return additionalServiceCodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return additionalServiceDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parseAdditionalServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return toFeatureBoolean; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


var ADDITIONAL_SERVICES = [{ code: 'crm', name: 'CRM', description: 'Gestión comercial y seguimiento de clientes.', icon: 'contacts' }, { code: 'deuna', name: 'Deuna', description: 'Cobros y pagos mediante la integración Deuna.', icon: 'account_balance_wallet' }, { code: 'cashback', name: 'Cashback', description: 'Devolución de un porcentaje de las compras a los clientes.', icon: 'redeem' }, { code: 'whatsapp', name: 'WhatsApp', description: 'Comunicación y envío de mensajes por WhatsApp.', icon: 'chat' }, { code: 'push_notifications', name: 'Notificaciones push', description: 'Avisos enviados directamente a dispositivos.', icon: 'notifications_active' }];

function toFeatureBoolean(value) {
	if (typeof value === 'string') return !['', '0', 'false', 'null'].includes(value.toLowerCase());
	return Boolean(value);
}

function parseAdditionalServices(plan) {
	var source = (plan || {}).additional_services;
	if (typeof source === 'string') {
		try {
			var parsed = JSON.parse(source);
			return parsed && (typeof parsed === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(parsed)) === 'object' ? parsed : {};
		} catch (error) {
			return {};
		}
	}
	return source && (typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(source)) === 'object' ? source : {};
}

function humanizeServiceCode(code) {
	var text = String(code).replace(/[_-]+/g, ' ').trim();
	return text.charAt(0).toUpperCase() + text.slice(1);
}

function additionalServiceDefinition(code) {
	return ADDITIONAL_SERVICES.find(function (service) {
		return service.code === code;
	}) || { code: code, name: humanizeServiceCode(code), description: 'Función adicional del plan.', icon: 'extension' };
}

function additionalServiceCodes(plan) {
	var stored = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(parseAdditionalServices(plan));
	var catalog = ADDITIONAL_SERVICES.map(function (service) {
		return service.code;
	});
	return catalog.concat(stored.filter(function (code) {
		return !catalog.includes(code);
	}));
}



/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__(609),
  addHours: __webpack_require__(627),
  addISOYears: __webpack_require__(628),
  addMilliseconds: __webpack_require__(610),
  addMinutes: __webpack_require__(630),
  addMonths: __webpack_require__(612),
  addQuarters: __webpack_require__(631),
  addSeconds: __webpack_require__(632),
  addWeeks: __webpack_require__(616),
  addYears: __webpack_require__(633),
  areRangesOverlapping: __webpack_require__(663),
  closestIndexTo: __webpack_require__(664),
  closestTo: __webpack_require__(665),
  compareAsc: __webpack_require__(611),
  compareDesc: __webpack_require__(617),
  differenceInCalendarDays: __webpack_require__(170),
  differenceInCalendarISOWeeks: __webpack_require__(666),
  differenceInCalendarISOYears: __webpack_require__(634),
  differenceInCalendarMonths: __webpack_require__(635),
  differenceInCalendarQuarters: __webpack_require__(667),
  differenceInCalendarWeeks: __webpack_require__(668),
  differenceInCalendarYears: __webpack_require__(637),
  differenceInDays: __webpack_require__(638),
  differenceInHours: __webpack_require__(669),
  differenceInISOYears: __webpack_require__(670),
  differenceInMilliseconds: __webpack_require__(613),
  differenceInMinutes: __webpack_require__(671),
  differenceInMonths: __webpack_require__(618),
  differenceInQuarters: __webpack_require__(672),
  differenceInSeconds: __webpack_require__(619),
  differenceInWeeks: __webpack_require__(673),
  differenceInYears: __webpack_require__(674),
  distanceInWords: __webpack_require__(640),
  distanceInWordsStrict: __webpack_require__(675),
  distanceInWordsToNow: __webpack_require__(676),
  eachDay: __webpack_require__(677),
  endOfDay: __webpack_require__(620),
  endOfHour: __webpack_require__(678),
  endOfISOWeek: __webpack_require__(679),
  endOfISOYear: __webpack_require__(680),
  endOfMinute: __webpack_require__(681),
  endOfMonth: __webpack_require__(642),
  endOfQuarter: __webpack_require__(682),
  endOfSecond: __webpack_require__(683),
  endOfToday: __webpack_require__(684),
  endOfTomorrow: __webpack_require__(685),
  endOfWeek: __webpack_require__(641),
  endOfYear: __webpack_require__(686),
  endOfYesterday: __webpack_require__(687),
  format: __webpack_require__(92),
  getDate: __webpack_require__(688),
  getDay: __webpack_require__(689),
  getDayOfYear: __webpack_require__(176),
  getDaysInMonth: __webpack_require__(615),
  getDaysInYear: __webpack_require__(690),
  getHours: __webpack_require__(691),
  getISODay: __webpack_require__(644),
  getISOWeek: __webpack_require__(174),
  getISOWeeksInYear: __webpack_require__(692),
  getISOYear: __webpack_require__(88),
  getMilliseconds: __webpack_require__(693),
  getMinutes: __webpack_require__(694),
  getMonth: __webpack_require__(695),
  getOverlappingDaysInRanges: __webpack_require__(696),
  getQuarter: __webpack_require__(636),
  getSeconds: __webpack_require__(697),
  getTime: __webpack_require__(698),
  getYear: __webpack_require__(699),
  isAfter: __webpack_require__(700),
  isBefore: __webpack_require__(701),
  isDate: __webpack_require__(93),
  isEqual: __webpack_require__(702),
  isFirstDayOfMonth: __webpack_require__(703),
  isFriday: __webpack_require__(704),
  isFuture: __webpack_require__(705),
  isLastDayOfMonth: __webpack_require__(706),
  isLeapYear: __webpack_require__(643),
  isMonday: __webpack_require__(707),
  isPast: __webpack_require__(708),
  isSameDay: __webpack_require__(709),
  isSameHour: __webpack_require__(645),
  isSameISOWeek: __webpack_require__(647),
  isSameISOYear: __webpack_require__(648),
  isSameMinute: __webpack_require__(649),
  isSameMonth: __webpack_require__(651),
  isSameQuarter: __webpack_require__(652),
  isSameSecond: __webpack_require__(654),
  isSameWeek: __webpack_require__(621),
  isSameYear: __webpack_require__(656),
  isSaturday: __webpack_require__(710),
  isSunday: __webpack_require__(711),
  isThisHour: __webpack_require__(712),
  isThisISOWeek: __webpack_require__(713),
  isThisISOYear: __webpack_require__(714),
  isThisMinute: __webpack_require__(715),
  isThisMonth: __webpack_require__(716),
  isThisQuarter: __webpack_require__(717),
  isThisSecond: __webpack_require__(718),
  isThisWeek: __webpack_require__(719),
  isThisYear: __webpack_require__(720),
  isThursday: __webpack_require__(721),
  isToday: __webpack_require__(722),
  isTomorrow: __webpack_require__(723),
  isTuesday: __webpack_require__(724),
  isValid: __webpack_require__(178),
  isWednesday: __webpack_require__(725),
  isWeekend: __webpack_require__(726),
  isWithinRange: __webpack_require__(727),
  isYesterday: __webpack_require__(728),
  lastDayOfISOWeek: __webpack_require__(729),
  lastDayOfISOYear: __webpack_require__(730),
  lastDayOfMonth: __webpack_require__(731),
  lastDayOfQuarter: __webpack_require__(732),
  lastDayOfWeek: __webpack_require__(657),
  lastDayOfYear: __webpack_require__(733),
  max: __webpack_require__(734),
  min: __webpack_require__(735),
  parse: __webpack_require__(17),
  setDate: __webpack_require__(736),
  setDay: __webpack_require__(737),
  setDayOfYear: __webpack_require__(738),
  setHours: __webpack_require__(739),
  setISODay: __webpack_require__(740),
  setISOWeek: __webpack_require__(741),
  setISOYear: __webpack_require__(629),
  setMilliseconds: __webpack_require__(742),
  setMinutes: __webpack_require__(743),
  setMonth: __webpack_require__(658),
  setQuarter: __webpack_require__(744),
  setSeconds: __webpack_require__(745),
  setYear: __webpack_require__(746),
  startOfDay: __webpack_require__(166),
  startOfHour: __webpack_require__(646),
  startOfISOWeek: __webpack_require__(57),
  startOfISOYear: __webpack_require__(168),
  startOfMinute: __webpack_require__(650),
  startOfMonth: __webpack_require__(747),
  startOfQuarter: __webpack_require__(653),
  startOfSecond: __webpack_require__(655),
  startOfToday: __webpack_require__(748),
  startOfTomorrow: __webpack_require__(749),
  startOfWeek: __webpack_require__(171),
  startOfYear: __webpack_require__(177),
  startOfYesterday: __webpack_require__(750),
  subDays: __webpack_require__(751),
  subHours: __webpack_require__(752),
  subISOYears: __webpack_require__(639),
  subMilliseconds: __webpack_require__(753),
  subMinutes: __webpack_require__(754),
  subMonths: __webpack_require__(755),
  subQuarters: __webpack_require__(756),
  subSeconds: __webpack_require__(757),
  subWeeks: __webpack_require__(758),
  subYears: __webpack_require__(759)
}


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__(57)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var getQuarter = __webpack_require__(636)
var parse = __webpack_require__(17)

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(171)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(613)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var differenceInCalendarISOYears = __webpack_require__(634)
var compareAsc = __webpack_require__(611)
var subISOYears = __webpack_require__(639)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(613)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMonths = __webpack_require__(618)

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInDays = __webpack_require__(638)

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var differenceInCalendarYears = __webpack_require__(637)
var compareAsc = __webpack_require__(611)

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(617)
var parse = __webpack_require__(17)
var differenceInSeconds = __webpack_require__(619)
var enLocale = __webpack_require__(175)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var distanceInWords = __webpack_require__(640)

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)
  var step = dirtyStep !== undefined ? dirtyStep : 1

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + step)
  }

  return dates
}

module.exports = eachDay


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var endOfWeek = __webpack_require__(641)

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(88)
var startOfISOWeek = __webpack_require__(57)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var endOfDay = __webpack_require__(620)

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),
/* 685 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),
/* 687 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var isLeapYear = __webpack_require__(643)

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(168)
var addWeeks = __webpack_require__(616)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var endOfDay = __webpack_require__(620)
var endOfMonth = __webpack_require__(642)

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(166)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var isSameHour = __webpack_require__(645)

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__(647)

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOYear = __webpack_require__(648)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMinute = __webpack_require__(649)

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__(651)

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var isSameQuarter = __webpack_require__(652)

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var isSameSecond = __webpack_require__(654)

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(621)

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__(656)

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(166)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(166)

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(166)

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__(657)

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(88)
var startOfISOWeek = __webpack_require__(57)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var addDays = __webpack_require__(609)

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var addDays = __webpack_require__(609)
var getISODay = __webpack_require__(644)

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var getISOWeek = __webpack_require__(174)

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)
var setMonth = __webpack_require__(658)

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(17)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(166)

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),
/* 749 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),
/* 750 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(609)

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

var addHours = __webpack_require__(627)

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(610)

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var addMinutes = __webpack_require__(630)

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(612)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var addQuarters = __webpack_require__(631)

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var addSeconds = __webpack_require__(632)

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__(616)

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__(633)

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_companies_company_form__ = __webpack_require__(924);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-new-company',
	components: {
		actionSidebar: __WEBPACK_IMPORTED_MODULE_0__components_shared_action_sidebar__["default"],
		companyForm: __WEBPACK_IMPORTED_MODULE_1__components_companies_company_form__["a" /* default */]
	},
	props: {
		codeProject: {
			type: String
		},
		codeCompany: {
			type: String
		},
		idCompany: {
			type: [Number, String]
		},
		nameCompany: {
			type: String
		}
	}
});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_six_four__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_six_four___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_six_four__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_shared_upload_image__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_plan_features__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_date_fns__);












var getFile = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee(fileInfo, index) {
		var newfile, words, lastItem, extension;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						newfile = {
							name: fileInfo.name.replace(/\s/g, '-'),
							base64data: fileInfo.sixFour
						};
						words = newfile.name.split('.');
						lastItem = words.length;
						extension = words[lastItem - 1];

						if (this.allowedFiles.indexOf(extension) > -1) {
							this.model.settings.serviceExternal[index].credential = newfile.base64data;
						} else {
							this.showNotification('Archivo no v\xE1lido, solo se permite ' + this.allowedFiles.join(','), 'warning');
						}

					case 5:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function getFile(_x, _x2) {
		return _ref.apply(this, arguments);
	};
}();

var created = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _ref3, record, recordSettings, serviceExternal, selectedPlans, selectedPlan, initialRequests, templateId;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						if (!(this.mode === 'edit')) {
							_context2.next = 8;
							break;
						}

						_context2.next = 3;
						return this.$http.get('company/' + this.companyId);

					case 3:
						_ref3 = _context2.sent;
						record = _ref3.data;

						if (record.data) {
							recordSettings = record.data.settings || {};
							serviceExternal = Array.isArray(recordSettings.serviceExternal) ? recordSettings.serviceExternal : [];
							selectedPlans = record.data.selectPlans;
							selectedPlan = Array.isArray(selectedPlans) ? selectedPlans[0] : selectedPlans;

							this.model = {
								idTemplate: record.data.templateId,
								idDistributor: record.data.distributorId,
								nombreComercial: record.data.nombreComercial || '',
								razonSocial: record.data.razonSocial || '',
								codeCompany: record.data.codeCompany || '',
								ruc: record.data.ruc || '',
								languages: record.data.languages || {},
								modules: [],
								settings: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, recordSettings, { serviceExternal: serviceExternal }),
								countryId: record.data.country && record.data.country.data ? record.data.country.data.id : undefined,
								flagAllowAccess: record.data.flagAllowAccess === 1,
								plans: selectedPlan
							};
							this.flagFranchises = Boolean(selectedPlan) && Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["e" /* toFeatureBoolean */])(selectedPlan.flag_franchises);
							this.flagKardex = Boolean(selectedPlan) && (Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["e" /* toFeatureBoolean */])(selectedPlan.flag_kardex) || Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["e" /* toFeatureBoolean */])(selectedPlan.kardex));
							this.recalculateKardex = selectedPlan && selectedPlan.recalculate_kardex ? Number(selectedPlan.recalculate_kardex) : 0;
							this.companyPlan = planLimitsFrom(selectedPlan);
							this.companyPlanHasLimit = Boolean(selectedPlan) && selectedPlan.subsidiaries_limit !== undefined && selectedPlan.subsidiaries_limit !== null;
							this.companyPlanServices = planServicesFrom(selectedPlan);
							this.companyPlanHasServices = planHandlesServices(selectedPlan);
							this.initialPlanSyncFingerprint = this.planSyncFingerprint();
							if (this.model.settings.serviceExternal.length === 0) {
								this.model.settings.serviceExternal = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.arrayDefault));
							} else {
								this.appMerge();
							}
							this.languagesByProject = record.data.languages || {};
						}
						_context2.next = 9;
						break;

					case 8:
						this.model.settings.serviceExternal = [].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.arrayDefault));

					case 9:
						if (this.model.codeCompany && this.model.codeCompany.length) {
							this.codeCompanyDisabled = true;
						}
						initialRequests = [this.loadTemplate(), this.loadDistributors(), this.loadCountries(), this.loadLanguages()];
						_context2.next = 13;
						return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a.all(initialRequests);

					case 13:
						_context2.next = 15;
						return this.loadApps();

					case 15:
						if (!(this.mode === 'create' && this.$route.query.templateId)) {
							_context2.next = 20;
							break;
						}

						templateId = Number(this.$route.query.templateId);

						this.model.idTemplate = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(templateId) ? this.$route.query.templateId : templateId;
						_context2.next = 20;
						return this.loadPlans(this.model.idTemplate);

					case 20:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function created() {
		return _ref2.apply(this, arguments);
	};
}();

var loadPlans = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3(event) {
		var headers, _ref5, response;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context3.prev = 1;

						if (this.mode === 'create') this.model.plans = null;
						_context3.next = 5;
						return this.$http.get('template/' + event, { headers: headers });

					case 5:
						_ref5 = _context3.sent;
						response = _ref5.data;

						if (!this.listTemplate.some(function (template) {
							return Number(template.id) === Number(response.data.id);
						})) {
							this.listTemplate.push(response.data);
						}
						this.plans = typeof response.data.plans === 'string' ? [] : response.data.plans;
						_context3.next = 14;
						break;

					case 11:
						_context3.prev = 11;
						_context3.t0 = _context3['catch'](1);

						this.showError();

					case 14:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[1, 11]]);
	}));

	return function loadPlans(_x3) {
		return _ref4.apply(this, arguments);
	};
}();

var loadCountries = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.prev = 0;
						_context4.next = 3;
						return this.$http.get('countries');

					case 3:
						response = _context4.sent;

						this.countries = response.data.data;
						_context4.next = 10;
						break;

					case 7:
						_context4.prev = 7;
						_context4.t0 = _context4['catch'](0);

						this.showError();

					case 10:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[0, 7]]);
	}));

	return function loadCountries() {
		return _ref6.apply(this, arguments);
	};
}();

var loadMasterCompanies = function () {
	var _ref7 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5() {
		var _ref8, response;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						_context5.prev = 0;
						_context5.next = 3;
						return this.$http.get('/projects/' + this.codeProject + '/company-parent', {
							params: { page: 1 }
						});

					case 3:
						_ref8 = _context5.sent;
						response = _ref8.data;

						this.masterCompanies = response.data;
						_context5.next = 11;
						break;

					case 8:
						_context5.prev = 8;
						_context5.t0 = _context5['catch'](0);

						this.showError();

					case 11:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[0, 8]]);
	}));

	return function loadMasterCompanies() {
		return _ref7.apply(this, arguments);
	};
}();

var companyExistsInCommercial = function () {
	var _ref9 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee6() {
		var response, _response, message;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						_context6.prev = 0;
						_context6.next = 3;
						return this.$httpSales.get('/companies/' + this.model.codeCompany + '/acl');

					case 3:
						response = _context6.sent;
						return _context6.abrupt('return', Boolean(response && response.data && response.data.id));

					case 7:
						_context6.prev = 7;
						_context6.t0 = _context6['catch'](0);
						_response = _context6.t0 && _context6.t0.response ? _context6.t0.response : {};
						message = _response.data && _response.data.message;

						if (!(_response.status === 404 || message === 'COMPANY_NOT_FOUND')) {
							_context6.next = 13;
							break;
						}

						return _context6.abrupt('return', false);

					case 13:
						throw _context6.t0;

					case 14:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this, [[0, 7]]);
	}));

	return function companyExistsInCommercial() {
		return _ref9.apply(this, arguments);
	};
}();

var updatePlanInCommercial = function () {
	var _ref10 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee7() {
		var plan, synchronizedPlan, currentDate, body;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
			while (1) {
				switch (_context7.prev = _context7.next) {
					case 0:
						plan = this.planForCommercial();

						if (plan) {
							_context7.next = 3;
							break;
						}

						return _context7.abrupt('return', false);

					case 3:
						_context7.next = 5;
						return this.companyExistsInCommercial();

					case 5:
						if (_context7.sent) {
							_context7.next = 7;
							break;
						}

						return _context7.abrupt('return', null);

					case 7:
						synchronizedPlan = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, plan);

						if (this.renewPlan) {
							currentDate = new Date();

							synchronizedPlan = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, synchronizedPlan, {
								start_date: Object(__WEBPACK_IMPORTED_MODULE_15_date_fns__["format"])(currentDate, 'YYYY-MM-DD HH:mm:ss'),
								end_date: Object(__WEBPACK_IMPORTED_MODULE_15_date_fns__["format"])(this.renewalEndValue, 'YYYY-MM-DD HH:mm:ss'),
								updated_at: Object(__WEBPACK_IMPORTED_MODULE_15_date_fns__["format"])(currentDate, 'YYYY-MM-DD HH:mm:ss')
							});
						}
						body = {
							plans: synchronizedPlan
						};
						_context7.next = 12;
						return this.$httpSales.patch('/companies/' + this.model.codeCompany + '/plans', body);

					case 12:
						return _context7.abrupt('return', true);

					case 13:
					case 'end':
						return _context7.stop();
				}
			}
		}, _callee7, this);
	}));

	return function updatePlanInCommercial() {
		return _ref10.apply(this, arguments);
	};
}();

var loadTemplate = function () {
	var _ref11 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee8() {
		var params, headers, response;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
			while (1) {
				switch (_context8.prev = _context8.next) {
					case 0:
						params = {
							page: 1
						};
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context8.prev = 2;
						_context8.next = 5;
						return this.$http.get('project/' + this.codeProject + '/template', { params: params, headers: headers });

					case 5:
						response = _context8.sent;

						this.listTemplate = response.data.data;
						_context8.next = 12;
						break;

					case 9:
						_context8.prev = 9;
						_context8.t0 = _context8['catch'](2);

						this.showError();

					case 12:
					case 'end':
						return _context8.stop();
				}
			}
		}, _callee8, this, [[2, 9]]);
	}));

	return function loadTemplate() {
		return _ref11.apply(this, arguments);
	};
}();

var loadDistributors = function () {
	var _ref12 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee9() {
		var response;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
			while (1) {
				switch (_context9.prev = _context9.next) {
					case 0:
						_context9.prev = 0;
						_context9.next = 3;
						return this.$http.get('distributaries');

					case 3:
						response = _context9.sent;

						this.listDistributors = response.data.data;
						_context9.next = 10;
						break;

					case 7:
						_context9.prev = 7;
						_context9.t0 = _context9['catch'](0);

						this.showError();

					case 10:
					case 'end':
						return _context9.stop();
				}
			}
		}, _callee9, this, [[0, 7]]);
	}));

	return function loadDistributors() {
		return _ref12.apply(this, arguments);
	};
}();

var loadApps = function () {
	var _ref13 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee10() {
		var _ref14, apps, requestedCodeApp, requestedApp, assignedApp, assignedApps;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
			while (1) {
				switch (_context10.prev = _context10.next) {
					case 0:
						_context10.prev = 0;
						_context10.next = 3;
						return this.$http.get('project/' + this.codeProject + '/apps');

					case 3:
						_ref14 = _context10.sent;
						apps = _ref14.data;

						this.apps = apps.data;

						if (this.apps.length) {
							_context10.next = 8;
							break;
						}

						return _context10.abrupt('return');

					case 8:
						requestedCodeApp = this.$route.query.codeApp;
						requestedApp = this.apps.find(function (app) {
							return app.codeApp === requestedCodeApp;
						});
						assignedApp = null;

						if (!(this.mode === 'edit' && this.model.codeCompany)) {
							_context10.next = 16;
							break;
						}

						_context10.next = 14;
						return this.loadCompanyApps();

					case 14:
						assignedApps = _context10.sent;

						assignedApp = this.apps.find(function (app) {
							return assignedApps.some(function (companyApp) {
								return companyApp.codeApp === app.codeApp;
							});
						});

					case 16:
						this.codeApp = (requestedApp || assignedApp || this.apps[0]).codeApp;
						_context10.next = 19;
						return this.loadModules(this.codeApp);

					case 19:
						_context10.next = 24;
						break;

					case 21:
						_context10.prev = 21;
						_context10.t0 = _context10['catch'](0);

						this.showError();

					case 24:
					case 'end':
						return _context10.stop();
				}
			}
		}, _callee10, this, [[0, 21]]);
	}));

	return function loadApps() {
		return _ref13.apply(this, arguments);
	};
}();

var loadCompanyApps = function () {
	var _ref15 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee11() {
		var headers, _ref16, response;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
			while (1) {
				switch (_context11.prev = _context11.next) {
					case 0:
						_context11.prev = 0;
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context11.next = 4;
						return this.$http.get('project/' + this.codeProject + '/company/' + this.model.codeCompany + '/apps', { headers: headers });

					case 4:
						_ref16 = _context11.sent;
						response = _ref16.data;
						return _context11.abrupt('return', Array.isArray(response.data) ? response.data : []);

					case 9:
						_context11.prev = 9;
						_context11.t0 = _context11['catch'](0);
						return _context11.abrupt('return', []);

					case 12:
					case 'end':
						return _context11.stop();
				}
			}
		}, _callee11, this, [[0, 9]]);
	}));

	return function loadCompanyApps() {
		return _ref15.apply(this, arguments);
	};
}();

var loadLanguages = function () {
	var _ref17 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee12() {
		var _this6 = this;

		var headers, _ref18, project, projectLanguages, companyLanguages, lang;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
			while (1) {
				switch (_context12.prev = _context12.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context12.prev = 1;
						_context12.next = 4;
						return this.$http.get('projects/' + this.codeProject, { headers: headers });

					case 4:
						_ref18 = _context12.sent;
						project = _ref18.data;
						projectLanguages = project && project.data && project.data.languages ? project.data.languages : {};
						companyLanguages = this.model.languages && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.model.languages) === 'object' && !Array.isArray(this.model.languages) ? this.model.languages : {};
						lang = {};

						__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(projectLanguages).forEach(function (pLangKey) {
							if (projectLanguages[pLangKey].isSelected) {
								var savedLanguage = companyLanguages[pLangKey];
								lang[pLangKey] = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, projectLanguages[pLangKey], savedLanguage || {}, {
									isSelected: _this6.mode === 'edit' ? Boolean(savedLanguage && savedLanguage.isSelected !== false) : false
								});
							}
						});
						__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(companyLanguages).forEach(function (companyLangKey) {
							if (!lang[companyLangKey]) {
								var savedLanguage = companyLanguages[companyLangKey] || {};
								lang[companyLangKey] = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, savedLanguage, {
									isSelected: savedLanguage.isSelected !== false
								});
							}
						});
						this.languagesByProject = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, lang);
						this.model.languages = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, lang);
						this.flagCompanyParent = Boolean(project.data.flagCompanyParent);
						if (this.flagCompanyParent) this.loadMasterCompanies();
						_context12.next = 20;
						break;

					case 17:
						_context12.prev = 17;
						_context12.t0 = _context12['catch'](1);

						this.showError();

					case 20:
					case 'end':
						return _context12.stop();
				}
			}
		}, _callee12, this, [[1, 17]]);
	}));

	return function loadLanguages() {
		return _ref17.apply(this, arguments);
	};
}();

var loadModules = function () {
	var _ref19 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee13(code) {
		var _this7 = this;

		var query, _ref20, modulesData, languagesEmpty, firstSelectedModuleIndex;

		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
			while (1) {
				switch (_context13.prev = _context13.next) {
					case 0:
						query = {
							params: {
								codeCompany: this.mode === 'edit' ? this.codeCompany : null,
								codeProject: this.mode === 'edit' ? this.codeProject : null
							},
							headers: {
								Accept: '' + 'application/vnd.apiacl.v2+json'
							}
						};
						_context13.prev = 1;
						_context13.next = 4;
						return this.$http.get('app/' + code + '/modules', query);

					case 4:
						_ref20 = _context13.sent;
						modulesData = _ref20.data;

						this.modules = modulesData.data.map(function (module) {
							var newModule = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, module);
							var index = _this7.model.modules.findIndex(function (modMod) {
								return modMod.id === module.id;
							});
							newModule.languages = {};
							newModule.isSelected = false;
							if (_this7.companyId && module.configLanguages) {
								newModule.languages = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, module.configLanguages.languages);
								newModule.isSelected = true;
								newModule.pathIcon = module.configLanguages.pathIcon;
								newModule.position = module.configLanguages.position;
								delete newModule.configLanguages;
								if (index < 0) {
									_this7.model.modules.push(newModule);
								}
							} else if (_this7.model.modules.length > 0) {
								if (index < 0) {
									_this7.model.modules.push(newModule);
								} else {
									newModule.isSelected = _this7.model.modules[index].isSelected;
									newModule.languages = _this7.model.modules[index].languages;
									newModule.pathIcon = _this7.model.modules[index].pathIcon;
									newModule.position = _this7.model.modules[index].position;
								}
							} else {
								_this7.model.modules.push(newModule);
							}
							return newModule;
						});
						languagesEmpty = true;

						__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(this.languagesByProject).forEach(function (key) {
							if (_this7.languagesByProject[key]) {
								languagesEmpty = false;
							}
						});
						if (!this.companyId && languagesEmpty) {
							this.loadLanguages();
						} else {
							__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(this.languagesByProject).forEach(function (key) {
								if (_this7.languagesByProject[key].isSelected) {
									_this7.selectLanguages(_this7.languagesByProject[key], key);
								}
							});
						}
						this.panel = this.modules.map(function (mod) {
							return mod.isSelected;
						});
						firstSelectedModuleIndex = this.modules.findIndex(function (mod) {
							return mod.isSelected;
						});

						this.activeModuleIndex = firstSelectedModuleIndex >= 0 ? firstSelectedModuleIndex : null;
						_context13.next = 18;
						break;

					case 15:
						_context13.prev = 15;
						_context13.t0 = _context13['catch'](1);

						this.showError();

					case 18:
					case 'end':
						return _context13.stop();
				}
			}
		}, _callee13, this, [[1, 15]]);
	}));

	return function loadModules(_x4) {
		return _ref19.apply(this, arguments);
	};
}();

var submitForm = function () {
	var _ref23 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee14() {
		var _this8 = this;

		var currentSettings, currentServices, serviceExternal, payload, headers, method, url, planChanged, selectedTemplate, commercialSyncFailed, planSynchronized, errorData, message;
		return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
			while (1) {
				switch (_context14.prev = _context14.next) {
					case 0:
						this.$v.$touch();

						if (!this.renewalDurationInvalid) {
							_context14.next = 4;
							break;
						}

						this.showError('Ingresa una duración de renovación válida, mayor a cero.');
						return _context14.abrupt('return');

					case 4:
						if (!(this.$v.$invalid || this.languageSelectionInvalid)) {
							_context14.next = 7;
							break;
						}

						if (this.languageSelectionInvalid) {
							this.showError('Debes seleccionar al menos un idioma para la compañía.');
						}
						return _context14.abrupt('return');

					case 7:
						currentSettings = this.model.settings || {};
						currentServices = Array.isArray(currentSettings.serviceExternal) ? currentSettings.serviceExternal : [];
						serviceExternal = currentServices.filter(function (service) {
							return service.flagSelected;
						}).map(function (service) {
							return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, service);
						});
						payload = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, this.model, {
							settings: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, currentSettings, {
								serviceExternal: serviceExternal
							})
						});

						payload.languages = this.languagesByProject;
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						method = this.mode === 'create' ? 'post' : 'put';
						url = this.mode === 'create' ? 'company/' + this.codeProject + '/project' : 'company/' + this.codeCompany;
						planChanged = this.mode === 'edit' && (this.hasPlanSyncChanges() || this.renewPlan);

						if (this.mode === 'edit') {
							payload.codeProject = this.codeProject;
							payload.flagAllowAccess = Number(this.model.flagAllowAccess);
							payload.renewPlan = this.renewPlan;
							payload.renewalAmount = Number(this.renewalAmount);
							payload.renewalUnit = this.renewalUnit;
							// Límite de empresas solo para esta compañía (se guarda en su copia del plan).
							// Solo se envía si la compañía ya tenía uno propio o si se cambió aquí.
							if (this.planHasSubsidiariesLimit && (this.companyPlanTouched || this.companyPlanHasLimit)) {
								payload.subsidiariesLimit = Math.max(0, Number(this.companyPlan.subsidiaries_limit) || 0);
							}
							if (this.planHasAdditionalServices && (this.companyPlanServicesTouched || this.companyPlanHasServices)) {
								payload.additionalServices = this.companyPlanServicesValues();
							}
						}
						this.loading = true;
						payload.plans = this.model.plans && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.model.plans) === 'object' ? this.model.plans.id : this.model.plans;
						if (this.mode === 'create' && this.model.idTemplate) {
							selectedTemplate = this.listTemplate.find(function (template) {
								return Number(template.id) === Number(_this8.model.idTemplate);
							});

							payload.codeProject = this.codeProject;
							payload.codeTemplate = selectedTemplate ? selectedTemplate.codeTemplate : this.$route.query.codeTemplate;
							payload.flagFranchises = Boolean(this.flagFranchises);
							payload.flagKardex = Number(this.flagKardex);
							payload.recalculateKardex = Number(this.recalculateKardex || 0);
							payload.flagAppCompany = true;
							payload.flagAllowAccess = Number(this.model.flagAllowAccess);
							url = 'company-template';
							method = 'post';
						}
						_context14.prev = 20;
						_context14.next = 23;
						return this.$http[method](url, payload, { headers: headers });

					case 23:
						commercialSyncFailed = false;

						if (!planChanged) {
							_context14.next = 35;
							break;
						}

						_context14.prev = 25;
						_context14.next = 28;
						return this.updatePlanInCommercial();

					case 28:
						planSynchronized = _context14.sent;

						commercialSyncFailed = planSynchronized === false;
						_context14.next = 35;
						break;

					case 32:
						_context14.prev = 32;
						_context14.t0 = _context14['catch'](25);

						commercialSyncFailed = true;

					case 35:
						if (commercialSyncFailed) {
							this.showNotification('La compañía se guardó en ACL, pero no se pudo sincronizar el plan con Comercial.', 'warning');
						} else if (this.renewPlan) {
							this.showNotification('La compañía y la vigencia del plan se actualizaron correctamente.');
						} else {
							this.showNotification('La información de la compañía se guardó correctamente.');
						}
						this.closeModal();
						_context14.next = 42;
						break;

					case 39:
						_context14.prev = 39;
						_context14.t1 = _context14['catch'](20);

						if (_context14.t1.status === 405) {
							if (_context14.t1.data.message === 'MODULE_HAS_ASSOCIATED_DATA') {
								this.showError('Los módulos con permisos asignados deben ser seleccionados para poder grabar la información.', 'info');
							}
						} else {
							errorData = _context14.t1 && _context14.t1.data ? _context14.t1.data : {};
							message = errorData.message || errorData.email || errorData.codeUser || errorData.codeCompany;

							this.showError(message || undefined);
						}

					case 42:
						_context14.prev = 42;

						this.loading = false;
						return _context14.finish(42);

					case 45:
					case 'end':
						return _context14.stop();
				}
			}
		}, _callee14, this, [[20, 39, 42, 45], [25, 32]]);
	}));

	return function submitForm() {
		return _ref23.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// Límite del plan que se puede ajustar solo para una compañía.
var PLAN_LIMIT_FIELDS = [{ key: 'subsidiaries_limit', label: 'Empresas / sucursales' }];

function planLimitsFrom(plan) {
	var source = plan || {};
	return PLAN_LIMIT_FIELDS.reduce(function (acc, field) {
		return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()({}, field.key, Number(source[field.key]) || 0));
	}, {});
}

function planHandlesServices(plan) {
	return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["d" /* parseAdditionalServices */])(plan)).length > 0;
}

function planServicesFrom(plan) {
	var source = Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["d" /* parseAdditionalServices */])(plan);
	return Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["b" /* additionalServiceCodes */])(plan).reduce(function (acc, code) {
		return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()({}, code, Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["e" /* toFeatureBoolean */])(source[code])));
	}, {});
}

var PAGE_COMPANY_LIST = 'page-company';

function showDialog(prop) {
	this.$refs[prop][0].click();
}

function changeState(index) {
	this.model.settings.serviceExternal[index].open = !this.model.settings.serviceExternal[index].open;
}

function planForCommercial() {
	if (!this.model.plans || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(this.model.plans) !== 'object') {
		return null;
	}
	return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, this.model.plans, {
		flag_franchises: Boolean(this.flagFranchises),
		flag_kardex: Boolean(this.flagKardex),
		recalculate_kardex: Number(this.recalculateKardex || 0)
	}, this.planHasSubsidiariesLimit ? this.companyPlanValues() : {}, this.planHasAdditionalServices ? { additional_services: this.companyPlanServicesValues() } : {});
}

function planSyncFingerprint() {
	var plan = this.planForCommercial();
	if (!plan) return null;
	var comparablePlan = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, plan);
	delete comparablePlan.created_at;
	delete comparablePlan.start_date;
	delete comparablePlan.end_date;
	delete comparablePlan.updated_at;
	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(comparablePlan);
}

function hasPlanSyncChanges() {
	return this.planSyncFingerprint() !== this.initialPlanSyncFingerprint;
}

function currentPlanEndDate() {
	var value = this.model.plans && this.model.plans.end_date;
	if (!value) return 'Sin fecha de caducidad';
	var normalizedValue = typeof value === 'string' ? value.replace(' ', 'T') : value;
	var endDate = new Date(normalizedValue);
	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_nan___default()(endDate.getTime())) return value;
	return endDate.toLocaleDateString('es-EC', {
		day: '2-digit',
		month: 'long',
		year: 'numeric'
	});
}

function renewalStartDate() {
	return Object(__WEBPACK_IMPORTED_MODULE_15_date_fns__["format"])(new Date(), 'DD/MM/YYYY');
}

function renewalEndValue() {
	var amount = Number(this.renewalAmount);
	if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(amount) || amount < 1) return new Date();
	if (this.renewalUnit === 'days') return Object(__WEBPACK_IMPORTED_MODULE_15_date_fns__["addDays"])(new Date(), amount);
	if (this.renewalUnit === 'months') return Object(__WEBPACK_IMPORTED_MODULE_15_date_fns__["addMonths"])(new Date(), amount);
	return Object(__WEBPACK_IMPORTED_MODULE_15_date_fns__["addYears"])(new Date(), amount);
}

function renewalEndDate() {
	return Object(__WEBPACK_IMPORTED_MODULE_15_date_fns__["format"])(this.renewalEndValue, 'DD/MM/YYYY');
}

function renewalDurationInvalid() {
	var amount = Number(this.renewalAmount);
	return this.renewPlan && (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(amount) || amount < 1 || !['days', 'months', 'years'].includes(this.renewalUnit));
}

function onPlanChange(plan) {
	this.companyPlan = planLimitsFrom(plan);
	this.companyPlanServices = planServicesFrom(plan);
	this.companyPlanHasServices = planHandlesServices(plan);
}

// Plan global seleccionado (sin los cambios de esta compañía).
function basePlan() {
	var id = this.model.plans && this.model.plans.id;
	return (this.plans || []).find(function (plan) {
		return Number(plan.id) === Number(id);
	}) || this.model.plans || {};
}

function resetCompanyPlan() {
	this.companyPlanTouched = true;
	this.companyPlanServicesTouched = true;
	this.companyPlan = planLimitsFrom(this.basePlan());
	this.companyPlanServices = planServicesFrom(this.basePlan());
}

function toggleCompanyPlanService(key) {
	this.companyPlanServicesTouched = true;
	this.$set(this.companyPlanServices, key, !this.companyPlanServices[key]);
}

function isPlanServiceChanged(key) {
	return Boolean(this.companyPlanServices[key]) !== Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["e" /* toFeatureBoolean */])(Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["d" /* parseAdditionalServices */])(this.basePlan())[key]);
}

function setPlanField(key, value) {
	this.companyPlanTouched = true;
	this.$set(this.companyPlan, key, Math.max(0, Number(value) || 0));
}

function isPlanFieldChanged(key) {
	return Number(this.companyPlan[key] || 0) !== Number(this.basePlan()[key] || 0);
}

// El apartado solo se muestra si el plan trae subsidiaries_limit.
function planHasSubsidiariesLimit() {
	var hasLimit = function hasLimit(plan) {
		return Boolean(plan) && (typeof plan === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(plan)) === 'object' && plan.subsidiaries_limit !== undefined && plan.subsidiaries_limit !== null;
	};
	return hasLimit(this.model.plans) || hasLimit(this.basePlan());
}

function planHasAdditionalServices() {
	return this.companyPlanServiceFields.length > 0;
}

function companyPlanSectionVisible() {
	return this.planHasSubsidiariesLimit || this.planHasAdditionalServices;
}

function companyPlanCustomized() {
	var _this = this;

	var limitChanged = this.planHasSubsidiariesLimit && this.companyPlanFields.some(function (field) {
		return _this.isPlanFieldChanged(field.key);
	});
	var serviceChanged = this.planHasAdditionalServices && this.companyPlanServiceFields.some(function (service) {
		return _this.isPlanServiceChanged(service.key);
	});
	return limitChanged || serviceChanged;
}

// Solo se sobrescribe el límite de empresas; el resto del plan queda igual.
function companyPlanValues() {
	var _this2 = this;

	return PLAN_LIMIT_FIELDS.reduce(function (values, field) {
		return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, values, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()({}, field.key, Math.max(0, Number(_this2.companyPlan[field.key]) || 0)));
	}, {});
}

function companyPlanServicesValues() {
	var _this3 = this;

	var stored = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["d" /* parseAdditionalServices */])(this.basePlan()), Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["d" /* parseAdditionalServices */])(this.model.plans));
	return this.companyPlanServiceFields.reduce(function (values, field) {
		return __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, values, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()({}, field.key, Boolean(_this3.companyPlanServices[field.key])));
	}, stored);
}

function companyPlanServiceFields() {
	var base = Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["d" /* parseAdditionalServices */])(this.basePlan());
	var own = Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["d" /* parseAdditionalServices */])(this.model.plans);
	var source = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, base, own);
	return Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["b" /* additionalServiceCodes */])({ additional_services: source }).filter(function (code) {
		return Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["e" /* toFeatureBoolean */])(base[code]) || Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["e" /* toFeatureBoolean */])(own[code]);
	}).map(function (code) {
		return Object(__WEBPACK_IMPORTED_MODULE_14__shared_plan_features__["c" /* additionalServiceDefinition */])(code);
	}).map(function (service) {
		return {
			key: service.code,
			label: service.name,
			description: service.description,
			icon: service.icon
		};
	});
}

function appMerge() {
	var _this4 = this;

	var newApps = this.arrayDefault.reduce(function (acum, item) {
		var modelIndex = _this4.model.settings.serviceExternal.findIndex(function (se) {
			return se.title === item.title;
		});
		if (modelIndex < 0) {
			acum.push(item);
		}
		return acum;
	}, []);
	this.model.settings.serviceExternal = this.model.settings.serviceExternal.concat(newApps);
}

function closeModal() {
	if (this.$route.query.returnTo === 'page-template') {
		this.goTo('page-template', { params: { codeProject: this.codeProject }, query: {} });
		return;
	}
	var codeProject = this.codeProject;
	this.goTo(PAGE_COMPANY_LIST, { params: { codeProject: codeProject } });
}

function expandDisabled() {
	var _this5 = this;

	var disabled = true;
	var languagesKeys = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(this.languagesByProject);
	languagesKeys.forEach(function (key) {
		if (_this5.languagesByProject[key].isSelected) {
			disabled = false;
		}
	});
	return disabled;
}

function hasLanguages() {
	return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_keys___default()(this.languagesByProject).length > 0;
}

function languageSelectionInvalid() {
	return this.expandDisabled;
}

function mode() {
	return this.companyId ? 'edit' : 'create';
}

function modelModulesEmpty() {
	return this.model.modules.every(function (modMod) {
		return !modMod.isSelected;
	});
}

function removeModelModule(mod, moduleIndex) {
	if (mod.isSelected) {
		this.activeModuleIndex = moduleIndex;
	} else if (this.activeModuleIndex === moduleIndex) {
		this.activeModuleIndex = null;
		this.moduleConfigDialog = false;
	}
	if (!mod.isSelected) {
		this.model.modules = this.model.modules.map(function (modModule) {
			var newModModule = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, modModule);
			if (modModule.id === mod.id) {
				newModModule.isSelected = false;
			}
			return newModModule;
		});
	} else {
		this.model.modules = this.model.modules.map(function (modModule) {
			var newModModule = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, modModule);
			if (modModule.id === mod.id) {
				newModModule.isSelected = true;
			}
			return newModModule;
		});
	}
}

function toggleModule(moduleIndex) {
	this.activeModuleIndex = moduleIndex;
	this.moduleConfigDialog = true;
}

function closeModuleConfig() {
	this.moduleConfigDialog = false;
}

function selectedModuleConfig() {
	if (this.activeModuleIndex === null) return null;
	return this.modules[this.activeModuleIndex] || null;
}

function selectLanguages(_ref21, key) {
	var id = _ref21.id,
	    isSelected = _ref21.isSelected;

	if (isSelected) {
		this.modules = this.modules.map(function (module) {
			var newModule = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, module);
			if (!module.configLanguages && !module.languages[key]) {
				var newLanguage = { id: id, name: '' };
				newModule.languages[key] = newLanguage;
			}
			return newModule;
		});
		this.model.modules = this.model.modules.map(function (modMod) {
			var newModMod = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, modMod);
			if (!modMod.configLanguages && !modMod.languages[key]) {
				var newModLanguage = { id: id, name: '' };
				newModMod.languages[key] = newModLanguage;
			}
			return newModMod;
		});
	} else if (this.expandDisabled) {
		this.modules = this.modules.map(function (module) {
			var newModule = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, module);
			newModule.isSelected = false;
			delete newModule.languages[key];
			return newModule;
		});
		this.model.modules = this.model.modules.map(function (mod) {
			var newMod = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, mod);
			newMod.isSelected = false;
			delete newMod.languages[key];
			return newMod;
		});
	} else {
		this.modules = this.modules.map(function (module) {
			var newModule = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, module);
			delete newModule.languages[key];
			return newModule;
		});
		this.model.modules = this.model.modules.map(function (modModule) {
			var newModModule = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, modModule);
			delete newModModule.languages[key];
			return newModModule;
		});
	}
}

function sendImage(_ref22) {
	var urlImage = _ref22.urlImage,
	    item = _ref22.item;

	this.modules = this.modules.map(function (mod) {
		var newMod = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, mod);
		if (item.id === mod.id) {
			newMod.pathIcon = urlImage;
		}
		return newMod;
	});
	this.model.modules = this.model.modules.map(function (modModule) {
		var newModModule = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, modModule);
		if (item.id === modModule.id) {
			newModModule.pathIcon = urlImage;
		}
		return newModModule;
	});
}

function setPosition(module) {
	var position = module.position;

	var indexMod = this.model.modules.findIndex(function (mod) {
		return mod.id === module.id;
	});
	this.model.modules[indexMod].position = position;
}

function validations() {
	var _this9 = this;

	var validation = {
		model: {
			nombreComercial: {
				required: __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["required"]
			},
			razonSocial: {
				required: __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["required"]
			},
			codeCompany: {
				required: __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["required"]
			},
			ruc: {
				required: __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["required"],
				minLength: Object(__WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["minLength"])(13)
			},
			idTemplate: {
				required: __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["required"]
			},
			countryId: {
				required: __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["required"]
			},
			plans: { required: Object(__WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["requiredIf"])(function () {
					return _this9.plans;
				}) },
			email: {
				required: Object(__WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["requiredIf"])(function createCompany() {
					return this.mode === 'create';
				}),
				email: __WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["email"]
			},
			codeUser: {
				required: Object(__WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["requiredIf"])(function createCompany() {
					return this.mode === 'create';
				})
			},
			password: {
				required: Object(__WEBPACK_IMPORTED_MODULE_12_vuelidate_lib_validators__["requiredIf"])(function createCompany() {
					return this.mode === 'create';
				})
			}
		}
	};
	return validation;
}

function data() {
	return {
		activeModuleIndex: null,
		moduleConfigDialog: false,
		open: false,
		listDistributors: [],
		allowedFiles: ['json'],
		apps: [],
		codeApp: '',
		countries: [],
		flagCompanyParent: false,
		languagesByProject: {},
		flagFranchises: false,
		flagKardex: false,
		recalculateKardex: 0,
		companyPlan: planLimitsFrom(null),
		companyPlanHasLimit: false,
		companyPlanTouched: false,
		companyPlanFields: PLAN_LIMIT_FIELDS,
		companyPlanServices: planServicesFrom(null),
		companyPlanHasServices: false,
		companyPlanServicesTouched: false,
		listTemplate: [],
		masterCompanies: [],
		loading: false,
		initialPlanSyncFingerprint: null,
		renewPlan: false,
		renewalAmount: 1,
		renewalUnit: 'years',
		renewalUnits: [{ text: 'Días', value: 'days' }, { text: 'Meses', value: 'months' }, { text: 'Años', value: 'years' }],
		arrayDefault: [{
			id: 1,
			title: 'FIREBASE',
			flagSelected: false,
			typeId: 1,
			databaseURL: null,
			credential: null,
			open: false
		}, {
			id: 2,
			title: 'NETLIFY',
			flagSelected: false,
			typeId: 2,
			databaseURL: null,
			credential: null,
			open: false
		}],
		model: {
			nombreComercial: '',
			razonSocial: '',
			codeCompany: '',
			countryId: null,
			companyParentId: null,
			email: '',
			codeUser: '',
			password: '',
			flagAllowAccess: false,
			idTemplate: null,
			idDistributor: null,
			ruc: '',
			plans: '',
			languages: {},
			modules: [],
			settings: {
				serviceExternal: [{
					id: 1,
					title: 'FIREBASE',
					flagSelected: false,
					typeId: 1,
					databaseURL: null,
					credential: null,
					open: false
				}, {
					id: 2,
					title: 'NETLIFY',
					flagSelected: false,
					typeId: 2,
					databaseURL: null,
					credential: null,
					open: false
				}]
			}
		},
		module: {},
		modules: [],
		panel: [],
		plans: [],
		codeCompanyDisabled: false
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'company-form',
	components: {
		uploadImage: __WEBPACK_IMPORTED_MODULE_13__components_shared_upload_image__["a" /* default */],
		VueSixFour: __WEBPACK_IMPORTED_MODULE_11_vue_six_four___default.a
	},
	computed: {
		companyPlanCustomized: companyPlanCustomized,
		companyPlanSectionVisible: companyPlanSectionVisible,
		companyPlanServiceFields: companyPlanServiceFields,
		planHasAdditionalServices: planHasAdditionalServices,
		planHasSubsidiariesLimit: planHasSubsidiariesLimit,
		currentPlanEndDate: currentPlanEndDate,
		expandDisabled: expandDisabled,
		hasLanguages: hasLanguages,
		languageSelectionInvalid: languageSelectionInvalid,
		mode: mode,
		modelModulesEmpty: modelModulesEmpty,
		renewalDurationInvalid: renewalDurationInvalid,
		renewalEndDate: renewalEndDate,
		renewalEndValue: renewalEndValue,
		renewalStartDate: renewalStartDate,
		selectedModuleConfig: selectedModuleConfig
	},
	created: created,
	data: data,
	methods: {
		changeState: changeState,
		closeModal: closeModal,
		closeModuleConfig: closeModuleConfig,
		getFile: getFile,
		appMerge: appMerge,
		loadApps: loadApps,
		loadCompanyApps: loadCompanyApps,
		loadCountries: loadCountries,
		loadDistributors: loadDistributors,
		loadLanguages: loadLanguages,
		loadMasterCompanies: loadMasterCompanies,
		loadModules: loadModules,
		loadTemplate: loadTemplate,
		removeModelModule: removeModelModule,
		selectLanguages: selectLanguages,
		setPosition: setPosition,
		sendImage: sendImage,
		showDialog: showDialog,
		submitForm: submitForm,
		toggleModule: toggleModule,
		loadPlans: loadPlans,
		hasPlanSyncChanges: hasPlanSyncChanges,
		companyExistsInCommercial: companyExistsInCommercial,
		planForCommercial: planForCommercial,
		planSyncFingerprint: planSyncFingerprint,
		updatePlanInCommercial: updatePlanInCommercial,
		onPlanChange: onPlanChange,
		basePlan: basePlan,
		resetCompanyPlan: resetCompanyPlan,
		setPlanField: setPlanField,
		isPlanFieldChanged: isPlanFieldChanged,
		isPlanServiceChanged: isPlanServiceChanged,
		toggleCompanyPlanService: toggleCompanyPlanService,
		companyPlanValues: companyPlanValues,
		companyPlanServicesValues: companyPlanServicesValues
	},
	props: {
		codeProject: {
			type: String
		},
		companyId: {
			type: [Number, String]
		},
		codeCompany: {
			type: String
		}
	},
	validations: validations
});

/***/ }),
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_form_vue__ = __webpack_require__(789);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7038e224_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_form_vue__ = __webpack_require__(933);
function injectStyle (ssrContext) {
  __webpack_require__(925)
  __webpack_require__(927)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7038e224"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_company_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7038e224_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_company_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(926);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("5c9116b4", content, true, {});

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.expansion-panel-modules[data-v-7038e224]{-webkit-box-shadow:none;box-shadow:none;padding-bottom:60px}.expansion-panel-modules .v-expansion-panel__header[data-v-7038e224]{padding:0 24px}.expansion-panel-modules .v-input[data-v-7038e224]{margin-top:0}.expansion-panel-modules .v-label[data-v-7038e224]{height:100%;width:100%}.expansion-disabled-modules[data-v-7038e224]{opacity:.6;pointer-events:none}.title-validations[data-v-7038e224]{color:#1a4338;font-family:Opens_bold;font-size:13px}.company-modules-column[data-v-7038e224]{padding-top:18px!important}.company-form-column[data-v-7038e224]{border-right:1px solid #e7edf2;min-width:0}.company-modules-column[data-v-7038e224]{border-right:0}.company-form-section-title[data-v-7038e224]{margin-bottom:11px}.company-form-section-title label[data-v-7038e224]{color:#29475f;font-family:Opens_bold;font-size:11px;letter-spacing:.06em}.company-form-section-title .divider[data-v-7038e224]{margin-top:7px}.company-plan-renewal[data-v-7038e224]{background:#f7faf9;border:1px solid #d7e4df;border-radius:10px;padding:11px 12px;-webkit-transition:background-color .2s ease,border-color .2s ease;transition:background-color .2s ease,border-color .2s ease}.company-plan-renewal.active[data-v-7038e224]{background:#eef7f3;border-color:#8bb7a9}.company-plan-limits[data-v-7038e224]{background:#f7faf9;border:1px solid #d7e4df;border-radius:10px;padding:11px 12px;-webkit-transition:background-color .2s ease,border-color .2s ease;transition:background-color .2s ease,border-color .2s ease}.company-plan-limits.active[data-v-7038e224]{background:#fff8ec;border-color:#e8c78a}.company-plan-limits-reset[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #d7e4df;border-radius:999px;color:#1a4338;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:11px;font-weight:600;gap:4px;padding:4px 10px}.company-plan-limits-reset .v-icon[data-v-7038e224]{color:#1a4338;font-size:15px}.company-plan-limits-reset[data-v-7038e224]:hover{border-color:#8bb7a9}.company-plan-limits-grid[data-v-7038e224]{display:grid;gap:8px;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));margin-top:10px}.company-plan-limits-field[data-v-7038e224]{background:#fff;border:1px solid #dce7e3;border-radius:8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:2px;padding:6px 10px;-webkit-transition:border-color .15s ease;transition:border-color .15s ease}.company-plan-limits-field span[data-v-7038e224]{color:#718681;font-size:10px;line-height:1.3}.company-plan-limits-field input[data-v-7038e224]{background:transparent;border:0;color:#1a4338;font-size:15px;font-weight:700;outline:0;padding:0;width:100%}.company-plan-limits-field[data-v-7038e224]:focus-within{border-color:#8bb7a9}.company-plan-limits-field.changed[data-v-7038e224]{border-color:#e8c78a}.company-plan-limits-field.changed span[data-v-7038e224]{color:#a06a00}.company-plan-features[data-v-7038e224]{border-top:1px solid #e5ede9;margin-top:12px;padding-top:11px}.company-plan-features-header[data-v-7038e224]{gap:9px;margin-bottom:10px}.company-plan-features-header>span[data-v-7038e224],.company-plan-features-header[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.company-plan-features-header>span[data-v-7038e224]{background:#eaf3ef;border:1px solid #d9e9e2;border-radius:9px;-webkit-box-flex:0;-ms-flex:0 0 30px;flex:0 0 30px;height:30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:30px}.company-plan-features-header>span .v-icon[data-v-7038e224]{color:#1a4338;font-size:17px}.company-plan-features-header>div[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.company-plan-features-header strong[data-v-7038e224]{color:#29445a;font-size:12px}.company-plan-features-header small[data-v-7038e224]{color:#82928e;font-size:9px}.plan-services-grid[data-v-7038e224]{display:grid;gap:8px;grid-template-columns:repeat(2,minmax(0,1fr))}.plan-service-card[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f7f9f8;border:1px solid #dfe7e3;border-radius:10px;color:#375248;display:-webkit-box;display:-ms-flexbox;display:flex;gap:9px;min-height:64px;padding:9px;text-align:left;-webkit-transition:.18s ease;transition:.18s ease;width:100%}.plan-service-card[data-v-7038e224]:hover{background:#f0f7f4;border-color:#a9c4b9;-webkit-transform:translateY(-1px);transform:translateY(-1px)}.plan-service-card-active[data-v-7038e224]{background:#eaf5f0;border-color:#72a792;-webkit-box-shadow:inset 3px 0 #1a4338;box-shadow:inset 3px 0 #1a4338}.plan-service-card-changed[data-v-7038e224]{border-color:#e8c78a}.plan-service-icon[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e7efeb;border-radius:9px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 34px;flex:0 0 34px;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:34px}.plan-service-icon .v-icon[data-v-7038e224]{color:#547267;font-size:18px}.plan-service-card-active .plan-service-icon[data-v-7038e224]{background:#1a4338}.plan-service-card-active .plan-service-icon .v-icon[data-v-7038e224]{color:#fff}.plan-service-copy[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0}.plan-service-copy strong[data-v-7038e224]{color:#315145;font-size:10px}.plan-service-copy small[data-v-7038e224]{color:#82928c;font-size:8px;line-height:1.35;margin-top:2px}.plan-service-action[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e6ece9;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 24px;flex:0 0 24px;height:24px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px}.plan-service-action .v-icon[data-v-7038e224]{color:#70847c;font-size:15px}.plan-service-card-active .plan-service-action[data-v-7038e224]{background:#1a4338}.plan-service-card-active .plan-service-action .v-icon[data-v-7038e224]{color:#fff}.company-plan-renewal-header[data-v-7038e224]{gap:9px}.company-plan-renewal-header[data-v-7038e224],.company-plan-renewal-icon[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.company-plan-renewal-icon[data-v-7038e224]{background:#e4f0ec;border-radius:8px;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:34px}.company-plan-renewal-icon .v-icon[data-v-7038e224]{color:#1a4338;font-size:20px}.company-plan-renewal-copy[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0}.company-plan-renewal-copy strong[data-v-7038e224]{color:#29475f;font-size:12px}.company-plan-renewal-copy small[data-v-7038e224]{color:#718681;font-size:10px;line-height:1.35;margin-top:2px}.company-plan-renewal-control[data-v-7038e224]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;margin:0;padding:0}.company-plan-expiration[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #dce7e3;border-radius:8px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;margin-top:10px;padding:8px 10px}.company-plan-expiration .v-icon[data-v-7038e224]{color:#1a4338;font-size:18px}.company-plan-expiration>div[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.company-plan-expiration span[data-v-7038e224]{color:#718681;font-size:9px;text-transform:uppercase}.company-plan-expiration strong[data-v-7038e224]{color:#29475f;font-size:12px;margin-top:1px}.company-plan-renewal-period[data-v-7038e224]{display:grid;gap:8px;grid-template-columns:minmax(82px,.8fr) minmax(110px,1.2fr);margin-top:10px}.company-plan-renewal-period .v-input[data-v-7038e224]{margin:0}.company-plan-renewal-dates[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-top:1px solid #d7e4df;display:grid;gap:7px;grid-template-columns:1fr auto 1fr;margin-top:10px;padding-top:10px}.company-plan-renewal-dates>div[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.company-plan-renewal-dates span[data-v-7038e224]{color:#718681;font-size:9px;text-transform:uppercase}.company-plan-renewal-dates strong[data-v-7038e224]{color:#1a4338;font-size:11px}.company-plan-renewal-dates .v-icon[data-v-7038e224]{color:#71958a;font-size:16px}.company-language-option[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:42px}.company-languages-section[data-v-7038e224]{background:#f7faf9;border:1px solid #d9e6e1;border-radius:10px;margin-bottom:10px;padding:11px 12px 9px}.company-languages-header[data-v-7038e224]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:4px}.company-languages-header label[data-v-7038e224]{color:#29475f;display:block;font-family:Opens_bold;font-size:11px;letter-spacing:.06em}.company-languages-header small[data-v-7038e224]{color:#7a8d88;display:block;font-size:10px;margin-top:2px}.company-languages-header>span[data-v-7038e224]{background:#e8f3ef;border-radius:10px;color:#1a4338;font-size:9px;font-weight:700;padding:3px 7px;text-transform:uppercase}.company-language-options[data-v-7038e224]{margin:0 -4px}.company-languages-empty[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#7b8e88;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:11px;gap:6px;padding:9px 0 4px}.company-languages-empty .v-icon[data-v-7038e224]{color:#8da39c;font-size:18px}.company-languages-error[data-v-7038e224]{color:#d44d61;display:block;font-size:10px;margin-top:2px}.company-settings-column .v-input--selection-controls[data-v-7038e224]{margin-top:2px}.company-user-title[data-v-7038e224]{margin-top:14px}.template-modules-info[data-v-7038e224]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;background:#eef6f3;border:1px solid #c8ddd6;border-radius:10px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px;margin-top:4px;padding:18px}.template-modules-info .v-icon[data-v-7038e224]{color:#1a4338}.template-modules-info strong[data-v-7038e224]{color:#1a4338;display:block;margin-bottom:6px}.template-modules-info p[data-v-7038e224]{color:#637b73;line-height:1.45;margin:0}@media(max-width:959px){.company-form-column[data-v-7038e224]{border-bottom:1px solid #e7edf2;border-right:0;padding-left:22px!important;padding-right:22px!important}}.company-modules-list[data-v-7038e224]{background:#f5f8fb;border:1px solid #dce6ee;border-radius:11px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:5px;max-height:calc(100vh - 310px);overflow-y:auto;padding:7px;scrollbar-color:#aac0d2 transparent;scrollbar-width:thin}.module-config-item[data-v-7038e224]{background:#fff;border:1px solid #e1e8ee;border-radius:9px;overflow:hidden;-webkit-transition:border-color .16s ease,-webkit-box-shadow .16s ease;transition:border-color .16s ease,-webkit-box-shadow .16s ease;transition:border-color .16s ease,box-shadow .16s ease;transition:border-color .16s ease,box-shadow .16s ease,-webkit-box-shadow .16s ease}.module-config-item.is-selected[data-v-7038e224]{border-color:#b9ddca}.module-config-item.is-open[data-v-7038e224]{border-color:#7fc9a1;-webkit-box-shadow:0 5px 13px rgba(31,101,66,.09);box-shadow:0 5px 13px rgba(31,101,66,.09)}.module-config-header[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:42px;padding:4px 7px 4px 10px}.module-config-header .module-config-check[data-v-7038e224]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;min-width:0}.module-config-header .v-input[data-v-7038e224]{-webkit-box-flex:1;-ms-flex:1;flex:1}.module-config-header button[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#edf6fd;border:0;border-radius:7px;color:#2677b9;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:9px;gap:3px;height:29px;padding:0 7px;pointer-events:auto;position:relative;z-index:4}.module-config-header button .icon[data-v-7038e224]{color:#2677b9;font-size:17px}.module-config-content[data-v-7038e224]{background:#fbfcfd;border-top:1px solid #e8eef3;display:block;height:auto;min-height:150px;overflow:visible;padding:10px 9px 7px;position:relative;visibility:visible}.module-config-content-title[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:2px;margin:0 4px 9px}.module-config-content-title strong[data-v-7038e224]{color:#294a63;font-size:12px}.module-config-content-title small[data-v-7038e224]{color:#7b8fa0;font-size:10px}@media(max-width:700px){.company-modules-list[data-v-7038e224]{max-height:52vh}.module-config-header button span[data-v-7038e224]{display:none}}", "", {"version":3,"sources":["/opt/build/repo/src/components/companies/company-form.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,0CAA0C,wBAAwB,gBAAgB,mBAAmB,CACpG,AACD,qEAAqE,cAAgB,CACpF,AACD,mDAAmD,YAAc,CAChE,AACD,mDAAmD,YAAY,UAAU,CACxE,AACD,6CAA6C,WAAW,mBAAmB,CAC1E,AACD,oCAAoC,cAAc,uBAAyB,cAAc,CACxF,AACD,yCAAyC,0BAA2B,CACnE,AACD,sCAAsC,+BAA+B,WAAW,CAC/E,AACD,yCAAyC,cAAc,CACtD,AACD,6CAA6C,kBAAkB,CAC9D,AACD,mDAAmD,cAAc,uBAAyB,eAAe,oBAAoB,CAC5H,AACD,sDAAsD,cAAc,CACnE,AACD,uCAAuC,mBAAmB,yBAAyB,mBAAmB,kBAAkB,mEAAmE,0DAA0D,CACpP,AACD,8CAA8C,mBAAmB,oBAAoB,CACpF,AACD,sCAAsC,mBAAmB,yBAAyB,mBAAmB,kBAAkB,mEAAmE,0DAA0D,CACnP,AACD,6CAA6C,mBAAmB,oBAAoB,CACnF,AACD,4CAA4C,yBAAyB,sBAAsB,mBAAmB,gBAAgB,yBAAyB,oBAAoB,cAAc,2BAA2B,2BAA2B,oBAAoB,mBAAmB,kBAAkB,cAAc,eAAe,gBAAgB,QAAQ,gBAAgB,CAC5W,AACD,oDAAoD,cAAc,cAAc,CAC/E,AACD,kDAAkD,oBAAoB,CACrE,AACD,2CAA2C,aAAa,QAAQ,0DAA4D,eAAe,CAC1I,AACD,4CAA4C,gBAAgB,yBAAyB,kBAAkB,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,iBAAiB,0CAA0C,iCAAiC,CACxW,AACD,iDAAiD,cAAc,eAAe,eAAe,CAC5F,AACD,kDAAkD,uBAAyB,SAAS,cAAc,eAAe,gBAAgB,UAAU,UAAU,UAAU,CAC9J,AACD,yDAAyD,oBAAoB,CAC5E,AACD,oDAAoD,oBAAoB,CACvE,AACD,yDAAyD,aAAa,CACrE,AACD,wCAAwC,6BAA6B,gBAAgB,gBAAgB,CACpG,AACD,+CAAsK,QAAQ,kBAAkB,CAC/L,AACD,mGAF+C,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,YAAa,CAGrK,AADD,oDAAsH,mBAAmB,yBAAyB,kBAAkB,AAAqD,mBAAmB,kBAAkB,cAAc,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CACrX,AACD,4DAA4D,cAAc,cAAc,CACvF,AACD,mDAAmD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,qBAAqB,CAC/M,AACD,sDAAsD,cAAc,cAAc,CACjF,AACD,qDAAqD,cAAc,aAAa,CAC/E,AACD,qCAAqC,aAAa,QAAQ,6CAA+C,CACxG,AACD,oCAAoC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,yBAAyB,mBAAmB,cAAc,oBAAoB,oBAAoB,aAAa,QAAQ,gBAAgB,YAAY,gBAAgB,6BAA6B,qBAAqB,UAAU,CACvV,AACD,0CAA0C,mBAAmB,qBAAqB,mCAAmC,0BAA0B,CAC9I,AACD,2CAA2C,mBAAmB,qBAAqB,uCAAuC,8BAA8B,CACvJ,AACD,4CAA4C,oBAAoB,CAC/D,AACD,oCAAoC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,kBAAkB,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CAC5U,AACD,4CAA4C,cAAc,cAAc,CACvE,AACD,8DAA8D,kBAAkB,CAC/E,AACD,sEAAsE,UAAU,CAC/E,AACD,oCAAoC,oBAAoB,oBAAoB,aAAa,mBAAmB,WAAW,OAAO,4BAA4B,6BAA6B,0BAA0B,sBAAsB,WAAW,CACjP,AACD,2CAA2C,cAAc,cAAc,CACtE,AACD,0CAA0C,cAAc,cAAc,iBAAiB,cAAc,CACpG,AACD,sCAAsC,yBAAyB,sBAAsB,mBAAmB,mBAAmB,kBAAkB,oBAAoB,oBAAoB,aAAa,mBAAmB,kBAAkB,cAAc,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CAC9U,AACD,8CAA8C,cAAc,cAAc,CACzE,AACD,gEAAgE,kBAAkB,CACjF,AACD,wEAAwE,UAAU,CACjF,AACD,8CAAqK,OAAO,CAC3K,AACD,0FAF8C,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,YAAa,CAGpK,AADD,4CAA8G,mBAAmB,kBAAkB,AAAqD,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CACjS,AACD,oDAAoD,cAAc,cAAc,CAC/E,AACD,4CAA4C,oBAAoB,oBAAoB,aAAa,mBAAmB,WAAW,OAAO,4BAA4B,6BAA6B,0BAA0B,sBAAsB,WAAW,CACzP,AACD,mDAAmD,cAAc,cAAc,CAC9E,AACD,kDAAkD,cAAc,eAAe,iBAAiB,cAAc,CAC7G,AACD,+CAA+C,mBAAmB,kBAAkB,cAAc,SAAS,SAAS,CACnH,AACD,0CAA0C,yBAAyB,sBAAsB,mBAAmB,gBAAgB,yBAAyB,kBAAkB,oBAAoB,oBAAoB,aAAa,QAAQ,gBAAgB,gBAAgB,CACnQ,AACD,kDAAkD,cAAc,cAAc,CAC7E,AACD,8CAA8C,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,qBAAqB,CAC1M,AACD,+CAA+C,cAAc,cAAc,wBAAwB,CAClG,AACD,iDAAiD,cAAc,eAAe,cAAc,CAC3F,AACD,8CAA8C,aAAa,QAAQ,4DAA+D,eAAe,CAChJ,AACD,uDAAuD,QAAQ,CAC9D,AACD,6CAA6C,yBAAyB,sBAAsB,mBAAmB,6BAA6B,aAAa,QAAQ,mCAAmC,gBAAgB,gBAAgB,CACnO,AACD,iDAAiD,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,qBAAqB,CAC7M,AACD,kDAAkD,cAAc,cAAc,wBAAwB,CACrG,AACD,oDAAoD,cAAc,cAAc,CAC/E,AACD,qDAAqD,cAAc,cAAc,CAChF,AACD,0CAA0C,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,eAAe,CAC/K,AACD,4CAA4C,mBAAmB,yBAAyB,mBAAmB,mBAAmB,qBAAqB,CAClJ,AACD,2CAA2C,wBAAwB,qBAAqB,uBAAuB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,8BAA8B,iBAAiB,CACjQ,AACD,iDAAiD,cAAc,cAAc,uBAAyB,eAAe,oBAAoB,CACxI,AACD,iDAAiD,cAAc,cAAc,eAAe,cAAc,CACzG,AACD,gDAAgD,mBAAmB,mBAAmB,cAAc,cAAc,gBAAgB,gBAAgB,wBAAwB,CACzK,AACD,2CAA2C,aAAa,CACvD,AACD,0CAA0C,yBAAyB,sBAAsB,mBAAmB,cAAc,oBAAoB,oBAAoB,aAAa,eAAe,QAAQ,iBAAiB,CACtN,AACD,kDAAkD,cAAc,cAAc,CAC7E,AACD,0CAA0C,cAAc,cAAc,eAAe,cAAc,CAClG,AACD,uEAAuE,cAAc,CACpF,AACD,qCAAqC,eAAe,CACnD,AACD,wCAAwC,wBAAwB,qBAAqB,uBAAuB,mBAAmB,yBAAyB,mBAAmB,oBAAoB,oBAAoB,aAAa,SAAS,eAAe,YAAY,CACnQ,AACD,gDAAgD,aAAa,CAC5D,AACD,+CAA+C,cAAc,cAAc,iBAAiB,CAC3F,AACD,0CAA0C,cAAc,iBAAiB,QAAQ,CAChF,AACD,wBACA,sCAAsC,gCAAgC,eAAe,4BAA6B,4BAA6B,CAC9I,CACA,AACD,uCAAuC,mBAAmB,yBAAyB,mBAAmB,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,+BAA+B,gBAAgB,YAAY,oCAAsC,oBAAoB,CAChY,AACD,qCAAqC,gBAAgB,yBAAyB,kBAAkB,gBAAgB,uEAAuE,+DAA+D,uDAAuD,mFAAmF,CAC/X,AACD,iDAAiD,oBAAoB,CACpE,AACD,6CAA6C,qBAAqB,kDAAkD,yCAAyC,CAC5J,AACD,uCAAuC,yBAAyB,sBAAsB,mBAAmB,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,8BAA8B,gBAAgB,wBAAwB,CAClR,AACD,4DAA4D,mBAAmB,kBAAkB,cAAc,WAAW,CACzH,AACD,gDAAgD,mBAAmB,WAAW,MAAM,CACnF,AACD,8CAA8C,yBAAyB,sBAAsB,mBAAmB,mBAAmB,SAAS,kBAAkB,cAAc,eAAe,oBAAoB,oBAAoB,aAAa,cAAc,QAAQ,YAAY,cAAc,oBAAoB,kBAAkB,SAAS,CAC9U,AACD,oDAAoD,cAAc,cAAc,CAC/E,AACD,wCAAwC,mBAAmB,6BAA6B,cAAc,YAAY,iBAAiB,iBAAiB,qBAAqB,kBAAkB,kBAAkB,CAC5M,AACD,8CAA8C,oBAAoB,oBAAoB,aAAa,4BAA4B,6BAA6B,0BAA0B,sBAAsB,QAAQ,gBAAgB,CACnO,AACD,qDAAqD,cAAc,cAAc,CAChF,AACD,oDAAoD,cAAc,cAAc,CAC/E,AACD,wBACA,uCAAuC,eAAe,CACrD,AACD,mDAAmD,YAAY,CAC9D,CACA","file":"company-form.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.expansion-panel-modules[data-v-7038e224]{-webkit-box-shadow:none;box-shadow:none;padding-bottom:60px\n}\n.expansion-panel-modules .v-expansion-panel__header[data-v-7038e224]{padding:0px 24px\n}\n.expansion-panel-modules .v-input[data-v-7038e224]{margin-top:0px\n}\n.expansion-panel-modules .v-label[data-v-7038e224]{height:100%;width:100%\n}\n.expansion-disabled-modules[data-v-7038e224]{opacity:.6;pointer-events:none\n}\n.title-validations[data-v-7038e224]{color:#1a4338;font-family:\"Opens_bold\";font-size:13px\n}\n.company-modules-column[data-v-7038e224]{padding-top:18px !important\n}\n.company-form-column[data-v-7038e224]{border-right:1px solid #e7edf2;min-width:0\n}\n.company-modules-column[data-v-7038e224]{border-right:0\n}\n.company-form-section-title[data-v-7038e224]{margin-bottom:11px\n}\n.company-form-section-title label[data-v-7038e224]{color:#29475f;font-family:\"Opens_bold\";font-size:11px;letter-spacing:.06em\n}\n.company-form-section-title .divider[data-v-7038e224]{margin-top:7px\n}\n.company-plan-renewal[data-v-7038e224]{background:#f7faf9;border:1px solid #d7e4df;border-radius:10px;padding:11px 12px;-webkit-transition:background-color .2s ease,border-color .2s ease;transition:background-color .2s ease,border-color .2s ease\n}\n.company-plan-renewal.active[data-v-7038e224]{background:#eef7f3;border-color:#8bb7a9\n}\n.company-plan-limits[data-v-7038e224]{background:#f7faf9;border:1px solid #d7e4df;border-radius:10px;padding:11px 12px;-webkit-transition:background-color .2s ease,border-color .2s ease;transition:background-color .2s ease,border-color .2s ease\n}\n.company-plan-limits.active[data-v-7038e224]{background:#fff8ec;border-color:#e8c78a\n}\n.company-plan-limits-reset[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #d7e4df;border-radius:999px;color:#1a4338;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;font-size:11px;font-weight:600;gap:4px;padding:4px 10px\n}\n.company-plan-limits-reset .v-icon[data-v-7038e224]{color:#1a4338;font-size:15px\n}\n.company-plan-limits-reset[data-v-7038e224]:hover{border-color:#8bb7a9\n}\n.company-plan-limits-grid[data-v-7038e224]{display:grid;gap:8px;grid-template-columns:repeat(auto-fill, minmax(150px, 1fr));margin-top:10px\n}\n.company-plan-limits-field[data-v-7038e224]{background:#fff;border:1px solid #dce7e3;border-radius:8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:2px;padding:6px 10px;-webkit-transition:border-color .15s ease;transition:border-color .15s ease\n}\n.company-plan-limits-field span[data-v-7038e224]{color:#718681;font-size:10px;line-height:1.3\n}\n.company-plan-limits-field input[data-v-7038e224]{background:rgba(0,0,0,0);border:0;color:#1a4338;font-size:15px;font-weight:700;outline:0;padding:0;width:100%\n}\n.company-plan-limits-field[data-v-7038e224]:focus-within{border-color:#8bb7a9\n}\n.company-plan-limits-field.changed[data-v-7038e224]{border-color:#e8c78a\n}\n.company-plan-limits-field.changed span[data-v-7038e224]{color:#a06a00\n}\n.company-plan-features[data-v-7038e224]{border-top:1px solid #e5ede9;margin-top:12px;padding-top:11px\n}\n.company-plan-features-header[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:9px;margin-bottom:10px\n}\n.company-plan-features-header>span[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#eaf3ef;border:1px solid #d9e9e2;border-radius:9px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 30px;flex:0 0 30px;height:30px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:30px\n}\n.company-plan-features-header>span .v-icon[data-v-7038e224]{color:#1a4338;font-size:17px\n}\n.company-plan-features-header>div[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.company-plan-features-header strong[data-v-7038e224]{color:#29445a;font-size:12px\n}\n.company-plan-features-header small[data-v-7038e224]{color:#82928e;font-size:9px\n}\n.plan-services-grid[data-v-7038e224]{display:grid;gap:8px;grid-template-columns:repeat(2, minmax(0, 1fr))\n}\n.plan-service-card[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#f7f9f8;border:1px solid #dfe7e3;border-radius:10px;color:#375248;display:-webkit-box;display:-ms-flexbox;display:flex;gap:9px;min-height:64px;padding:9px;text-align:left;-webkit-transition:.18s ease;transition:.18s ease;width:100%\n}\n.plan-service-card[data-v-7038e224]:hover{background:#f0f7f4;border-color:#a9c4b9;-webkit-transform:translateY(-1px);transform:translateY(-1px)\n}\n.plan-service-card-active[data-v-7038e224]{background:#eaf5f0;border-color:#72a792;-webkit-box-shadow:inset 3px 0 #1a4338;box-shadow:inset 3px 0 #1a4338\n}\n.plan-service-card-changed[data-v-7038e224]{border-color:#e8c78a\n}\n.plan-service-icon[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e7efeb;border-radius:9px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 34px;flex:0 0 34px;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:34px\n}\n.plan-service-icon .v-icon[data-v-7038e224]{color:#547267;font-size:18px\n}\n.plan-service-card-active .plan-service-icon[data-v-7038e224]{background:#1a4338\n}\n.plan-service-card-active .plan-service-icon .v-icon[data-v-7038e224]{color:#fff\n}\n.plan-service-copy[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0\n}\n.plan-service-copy strong[data-v-7038e224]{color:#315145;font-size:10px\n}\n.plan-service-copy small[data-v-7038e224]{color:#82928c;font-size:8px;line-height:1.35;margin-top:2px\n}\n.plan-service-action[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e6ece9;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 0 24px;flex:0 0 24px;height:24px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px\n}\n.plan-service-action .v-icon[data-v-7038e224]{color:#70847c;font-size:15px\n}\n.plan-service-card-active .plan-service-action[data-v-7038e224]{background:#1a4338\n}\n.plan-service-card-active .plan-service-action .v-icon[data-v-7038e224]{color:#fff\n}\n.company-plan-renewal-header[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;gap:9px\n}\n.company-plan-renewal-icon[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#e4f0ec;border-radius:8px;display:-webkit-box;display:-ms-flexbox;display:flex;height:34px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:34px\n}\n.company-plan-renewal-icon .v-icon[data-v-7038e224]{color:#1a4338;font-size:20px\n}\n.company-plan-renewal-copy[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-width:0\n}\n.company-plan-renewal-copy strong[data-v-7038e224]{color:#29475f;font-size:12px\n}\n.company-plan-renewal-copy small[data-v-7038e224]{color:#718681;font-size:10px;line-height:1.35;margin-top:2px\n}\n.company-plan-renewal-control[data-v-7038e224]{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;margin:0;padding:0\n}\n.company-plan-expiration[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #dce7e3;border-radius:8px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:8px;margin-top:10px;padding:8px 10px\n}\n.company-plan-expiration .v-icon[data-v-7038e224]{color:#1a4338;font-size:18px\n}\n.company-plan-expiration>div[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.company-plan-expiration span[data-v-7038e224]{color:#718681;font-size:9px;text-transform:uppercase\n}\n.company-plan-expiration strong[data-v-7038e224]{color:#29475f;font-size:12px;margin-top:1px\n}\n.company-plan-renewal-period[data-v-7038e224]{display:grid;gap:8px;grid-template-columns:minmax(82px, 0.8fr) minmax(110px, 1.2fr);margin-top:10px\n}\n.company-plan-renewal-period .v-input[data-v-7038e224]{margin:0\n}\n.company-plan-renewal-dates[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-top:1px solid #d7e4df;display:grid;gap:7px;grid-template-columns:1fr auto 1fr;margin-top:10px;padding-top:10px\n}\n.company-plan-renewal-dates>div[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n.company-plan-renewal-dates span[data-v-7038e224]{color:#718681;font-size:9px;text-transform:uppercase\n}\n.company-plan-renewal-dates strong[data-v-7038e224]{color:#1a4338;font-size:11px\n}\n.company-plan-renewal-dates .v-icon[data-v-7038e224]{color:#71958a;font-size:16px\n}\n.company-language-option[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:42px\n}\n.company-languages-section[data-v-7038e224]{background:#f7faf9;border:1px solid #d9e6e1;border-radius:10px;margin-bottom:10px;padding:11px 12px 9px\n}\n.company-languages-header[data-v-7038e224]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;margin-bottom:4px\n}\n.company-languages-header label[data-v-7038e224]{color:#29475f;display:block;font-family:\"Opens_bold\";font-size:11px;letter-spacing:.06em\n}\n.company-languages-header small[data-v-7038e224]{color:#7a8d88;display:block;font-size:10px;margin-top:2px\n}\n.company-languages-header>span[data-v-7038e224]{background:#e8f3ef;border-radius:10px;color:#1a4338;font-size:9px;font-weight:700;padding:3px 7px;text-transform:uppercase\n}\n.company-language-options[data-v-7038e224]{margin:0 -4px\n}\n.company-languages-empty[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:#7b8e88;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:11px;gap:6px;padding:9px 0 4px\n}\n.company-languages-empty .v-icon[data-v-7038e224]{color:#8da39c;font-size:18px\n}\n.company-languages-error[data-v-7038e224]{color:#d44d61;display:block;font-size:10px;margin-top:2px\n}\n.company-settings-column .v-input--selection-controls[data-v-7038e224]{margin-top:2px\n}\n.company-user-title[data-v-7038e224]{margin-top:14px\n}\n.template-modules-info[data-v-7038e224]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;background:#eef6f3;border:1px solid #c8ddd6;border-radius:10px;display:-webkit-box;display:-ms-flexbox;display:flex;gap:12px;margin-top:4px;padding:18px\n}\n.template-modules-info .v-icon[data-v-7038e224]{color:#1a4338\n}\n.template-modules-info strong[data-v-7038e224]{color:#1a4338;display:block;margin-bottom:6px\n}\n.template-modules-info p[data-v-7038e224]{color:#637b73;line-height:1.45;margin:0\n}\n@media(max-width: 959px){\n.company-form-column[data-v-7038e224]{border-bottom:1px solid #e7edf2;border-right:0;padding-left:22px !important;padding-right:22px !important\n}\n}\n.company-modules-list[data-v-7038e224]{background:#f5f8fb;border:1px solid #dce6ee;border-radius:11px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:5px;max-height:calc(100vh - 310px);overflow-y:auto;padding:7px;scrollbar-color:#aac0d2 rgba(0,0,0,0);scrollbar-width:thin\n}\n.module-config-item[data-v-7038e224]{background:#fff;border:1px solid #e1e8ee;border-radius:9px;overflow:hidden;-webkit-transition:border-color .16s ease,-webkit-box-shadow .16s ease;transition:border-color .16s ease,-webkit-box-shadow .16s ease;transition:border-color .16s ease,box-shadow .16s ease;transition:border-color .16s ease,box-shadow .16s ease,-webkit-box-shadow .16s ease\n}\n.module-config-item.is-selected[data-v-7038e224]{border-color:#b9ddca\n}\n.module-config-item.is-open[data-v-7038e224]{border-color:#7fc9a1;-webkit-box-shadow:0 5px 13px rgba(31,101,66,.09);box-shadow:0 5px 13px rgba(31,101,66,.09)\n}\n.module-config-header[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:42px;padding:4px 7px 4px 10px\n}\n.module-config-header .module-config-check[data-v-7038e224]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;min-width:0\n}\n.module-config-header .v-input[data-v-7038e224]{-webkit-box-flex:1;-ms-flex:1;flex:1\n}\n.module-config-header button[data-v-7038e224]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#edf6fd;border:0;border-radius:7px;color:#2677b9;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:9px;gap:3px;height:29px;padding:0 7px;pointer-events:auto;position:relative;z-index:4\n}\n.module-config-header button .icon[data-v-7038e224]{color:#2677b9;font-size:17px\n}\n.module-config-content[data-v-7038e224]{background:#fbfcfd;border-top:1px solid #e8eef3;display:block;height:auto;min-height:150px;overflow:visible;padding:10px 9px 7px;position:relative;visibility:visible\n}\n.module-config-content-title[data-v-7038e224]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:2px;margin:0 4px 9px\n}\n.module-config-content-title strong[data-v-7038e224]{color:#294a63;font-size:12px\n}\n.module-config-content-title small[data-v-7038e224]{color:#7b8fa0;font-size:10px\n}\n@media(max-width: 700px){\n.company-modules-list[data-v-7038e224]{max-height:52vh\n}\n.module-config-header button span[data-v-7038e224]{display:none\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(928);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(516)("390b5044", content, true, {});

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(515)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_bold;src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Lato_light;src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:400;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:400;font-style:normal}.company-modules-list .module-config-item{display:block!important;min-height:44px!important}.company-modules-list .module-config-header{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;height:auto!important;-webkit-box-pack:justify!important;-ms-flex-pack:justify!important;justify-content:space-between!important;min-height:42px!important;visibility:visible!important}.company-modules-list .module-config-check{-webkit-box-flex:1!important;-ms-flex:1 1 auto!important;flex:1 1 auto!important;min-width:0!important}.company-modules-list .module-config-check>.input-group,.company-modules-list .module-config-check>.v-input{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-flex:1!important;-ms-flex:1 1 auto!important;flex:1 1 auto!important;height:34px!important;margin:0!important;max-height:34px!important;min-height:34px!important;opacity:1;padding:0!important;visibility:visible!important}.company-modules-list .module-config-header .input-group__input,.company-modules-list .module-config-header .v-input__control,.company-modules-list .module-config-header .v-input__slot{height:34px!important;min-height:34px!important}.company-modules-list .module-config-header label{color:#38536a!important;font-size:12px!important;opacity:1!important;visibility:visible!important}.company-modules-list .module-config-header .input-group__input,.company-modules-list .module-config-header .v-input__slot{max-width:100%}.company-modules-list .module-config-header>button{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;pointer-events:auto!important;position:relative;z-index:5}.company-modules-list .module-config-item.is-open{height:auto!important;max-height:none!important}.company-modules-list .module-config-item.is-open>.module-config-content{display:block!important;height:auto!important;min-height:150px!important;overflow:visible!important;opacity:1!important;visibility:visible!important}.module-config-dialog{border-radius:14px!important;overflow:hidden!important}.module-config-card{background:#fff!important}.module-config-dialog-header{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;background:linear-gradient(135deg,#f7fbff,#eef7fd);border-bottom:1px solid #dce8f1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:18px 20px 15px}.module-config-dialog-header small{color:#2580c6;font-size:9px;font-weight:700;letter-spacing:.1em}.module-config-dialog-header h3{color:#29465e;font-size:18px;margin:3px 0}.module-config-dialog-header p{color:#71879a;font-size:11px;margin:0}.module-config-dialog-header button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #d6e3ed;border-radius:8px;display:-webkit-box;display:-ms-flexbox;display:flex;height:32px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px}.module-config-dialog-header button .icon{color:#627b8f;font-size:19px}.module-config-dialog .module-config-content{background:#fff!important;border:0!important;max-height:58vh;min-height:190px!important;overflow-y:auto!important;padding:18px 22px!important}.module-config-dialog-actions{background:#f8fafc;border-top:1px solid #e1e9f0;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:10px 18px!important}", "", {"version":3,"sources":["/opt/build/repo/src/components/companies/company-form.vue"],"names":[],"mappings":"AACA,WAAW,yBAA2B,0CAA0C,gBAAmB,iBAAiB,CACnH,AACD,WAAW,sBAAwB,uCAAuC,gBAAmB,iBAAiB,CAC7G,AACD,WAAW,uBAAyB,wCAAwC,gBAAmB,iBAAiB,CAC/G,AACD,WAAW,0BAA4B,8CAA8C,gBAAmB,iBAAiB,CACxH,AACD,WAAW,uBAAyB,2CAA2C,gBAAmB,iBAAiB,CAClH,AACD,WAAW,2BAA6B,+CAA+C,gBAAmB,iBAAiB,CAC1H,AACD,WAAW,wBAA0B,4CAA4C,gBAAmB,iBAAiB,CACpH,AACD,0CAA0C,wBAAyB,yBAA0B,CAC5F,AACD,4CAA4C,mCAAoC,gCAAiC,6BAA8B,8BAA+B,8BAA+B,uBAAwB,sBAAuB,mCAAoC,gCAAiC,wCAAyC,0BAA2B,4BAA6B,CACja,AACD,2CAA2C,6BAA8B,4BAA6B,wBAAyB,qBAAsB,CACpJ,AACD,4GAA4G,8BAA+B,8BAA+B,uBAAwB,6BAA8B,4BAA6B,wBAAyB,sBAAuB,mBAAoB,0BAA2B,0BAA2B,UAAU,oBAAqB,4BAA6B,CAClb,AACD,yLAAyL,sBAAuB,yBAA0B,CACzO,AACD,kDAAkD,wBAAyB,yBAA0B,oBAAqB,4BAA6B,CACtJ,AACD,2HAA2H,cAAc,CACxI,AACD,mDAAmD,mBAAmB,kBAAkB,cAAc,8BAA+B,kBAAkB,SAAS,CAC/J,AACD,kDAAkD,sBAAuB,yBAA0B,CAClG,AACD,yEAAyE,wBAAyB,sBAAuB,2BAA4B,2BAA4B,oBAAqB,4BAA6B,CAClO,AACD,sBAAsB,6BAA8B,yBAA0B,CAC7E,AACD,oBAAoB,yBAA0B,CAC7C,AACD,6BAA6B,wBAAwB,qBAAqB,uBAAuB,mDAA6D,gCAAgC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,8BAA8B,sBAAsB,CACrV,AACD,mCAAmC,cAAc,cAAc,gBAAgB,mBAAmB,CACjG,AACD,gCAAgC,cAAc,eAAe,YAAY,CACxE,AACD,+BAA+B,cAAc,eAAe,QAAQ,CACnE,AACD,oCAAoC,yBAAyB,sBAAsB,mBAAmB,gBAAgB,yBAAyB,kBAAkB,oBAAoB,oBAAoB,aAAa,YAAY,wBAAwB,qBAAqB,uBAAuB,UAAU,CAC/S,AACD,0CAA0C,cAAc,cAAc,CACrE,AACD,6CAA6C,0BAA2B,mBAAoB,gBAAgB,2BAA4B,0BAA2B,2BAA4B,CAC9L,AACD,8BAA8B,mBAAmB,6BAA6B,qBAAqB,kBAAkB,yBAAyB,2BAA4B,CACzK","file":"company-form.vue","sourcesContent":["\n@font-face{font-family:\"Lato_regular\";src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_bold\";src:url(\"/static/fonts/Lato-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Lato_light\";src:url(\"/static/fonts/Lato-Light.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_regular\";src:url(\"/static/fonts/OpenSans-Regular.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_bold\";src:url(\"/static/fonts/OpenSans-Bold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_semibold\";src:url(\"/static/fonts/OpenSans-SemiBold.ttf\");font-weight:normal;font-style:normal\n}\n@font-face{font-family:\"Opens_light\";src:url(\"/static/fonts/OpenSans-Light.ttf\");font-weight:normal;font-style:normal\n}\n.company-modules-list .module-config-item{display:block !important;min-height:44px !important\n}\n.company-modules-list .module-config-header{-webkit-box-align:center !important;-ms-flex-align:center !important;align-items:center !important;display:-webkit-box !important;display:-ms-flexbox !important;display:flex !important;height:auto !important;-webkit-box-pack:justify !important;-ms-flex-pack:justify !important;justify-content:space-between !important;min-height:42px !important;visibility:visible !important\n}\n.company-modules-list .module-config-check{-webkit-box-flex:1 !important;-ms-flex:1 1 auto !important;flex:1 1 auto !important;min-width:0 !important\n}\n.company-modules-list .module-config-check>.v-input,.company-modules-list .module-config-check>.input-group{display:-webkit-box !important;display:-ms-flexbox !important;display:flex !important;-webkit-box-flex:1 !important;-ms-flex:1 1 auto !important;flex:1 1 auto !important;height:34px !important;margin:0 !important;max-height:34px !important;min-height:34px !important;opacity:1;padding:0 !important;visibility:visible !important\n}\n.company-modules-list .module-config-header .v-input__control,.company-modules-list .module-config-header .v-input__slot,.company-modules-list .module-config-header .input-group__input{height:34px !important;min-height:34px !important\n}\n.company-modules-list .module-config-header label{color:#38536a !important;font-size:12px !important;opacity:1 !important;visibility:visible !important\n}\n.company-modules-list .module-config-header .v-input__slot,.company-modules-list .module-config-header .input-group__input{max-width:100%\n}\n.company-modules-list .module-config-header>button{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;pointer-events:auto !important;position:relative;z-index:5\n}\n.company-modules-list .module-config-item.is-open{height:auto !important;max-height:none !important\n}\n.company-modules-list .module-config-item.is-open>.module-config-content{display:block !important;height:auto !important;min-height:150px !important;overflow:visible !important;opacity:1 !important;visibility:visible !important\n}\n.module-config-dialog{border-radius:14px !important;overflow:hidden !important\n}\n.module-config-card{background:#fff !important\n}\n.module-config-dialog-header{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;background:linear-gradient(135deg, #f7fbff 0%, #eef7fd 100%);border-bottom:1px solid #dce8f1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:18px 20px 15px\n}\n.module-config-dialog-header small{color:#2580c6;font-size:9px;font-weight:700;letter-spacing:.1em\n}\n.module-config-dialog-header h3{color:#29465e;font-size:18px;margin:3px 0\n}\n.module-config-dialog-header p{color:#71879a;font-size:11px;margin:0\n}\n.module-config-dialog-header button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:#fff;border:1px solid #d6e3ed;border-radius:8px;display:-webkit-box;display:-ms-flexbox;display:flex;height:32px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px\n}\n.module-config-dialog-header button .icon{color:#627b8f;font-size:19px\n}\n.module-config-dialog .module-config-content{background:#fff !important;border:0 !important;max-height:58vh;min-height:190px !important;overflow-y:auto !important;padding:18px 22px !important\n}\n.module-config-dialog-actions{background:#f8fafc;border-top:1px solid #e1e9f0;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding:10px 18px !important\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(930), __esModule: true };

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(931);
module.exports = __webpack_require__(5).Number.isInteger;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(14);

$export($export.S, 'Number', { isInteger: __webpack_require__(932) });


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(19);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-form',{attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm.apply(null, arguments)}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"company-form-column company-identity-column",attrs:{"xs12":"","md4":"","pl-4":"","pr-3":"","pt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"company-form-section-title",attrs:{"xs12":""}},[_c('label',[_vm._v("DATOS DE LA COMPAÑÍA")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Nombre","required":"","error":_vm.$v.model.nombreComercial.$error},model:{value:(_vm.$v.model.nombreComercial.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.nombreComercial, "$model", $$v)},expression:"$v.model.nombreComercial.$model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Razón Social","required":"","error":_vm.$v.model.razonSocial.$error},model:{value:(_vm.$v.model.razonSocial.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.razonSocial, "$model", $$v)},expression:"$v.model.razonSocial.$model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Código","required":"","disabled":_vm.codeCompanyDisabled,"error":_vm.$v.model.codeCompany.$error},model:{value:(_vm.$v.model.codeCompany.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.codeCompany, "$model", $$v)},expression:"$v.model.codeCompany.$model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-1":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Ruc","required":"","type":"number","error":_vm.$v.model.ruc.$error},model:{value:(_vm.$v.model.ruc.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.ruc, "$model", $$v)},expression:"$v.model.ruc.$model"}}),_vm._v(" "),(!_vm.$v.model.ruc.required)?_c('span',{staticClass:"form-group__message"},[_vm._v("\n\t\t\t\t\t\t\t\tEs necesario llenar este campo, es obligatorio.\n\t\t\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(!_vm.$v.model.ruc.minLength)?_c('span',{staticClass:"form-group__message"},[_vm._v("\n\t\t\t\t\t\t\t\tMínimo 13 caracteres numericos.\n\t\t\t\t\t\t\t")]):_vm._e()],1),_vm._v(" "),(_vm.mode === 'create')?[_c('v-flex',{staticClass:"company-form-section-title company-user-title",attrs:{"xs12":""}},[_c('label',[_vm._v("USUARIO ADMINISTRADOR")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Correo del administrador","type":"email","error":_vm.$v.model.email.$error},model:{value:(_vm.$v.model.email.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.email, "$model", $$v)},expression:"$v.model.email.$model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Código de usuario","error":_vm.$v.model.codeUser.$error},model:{value:(_vm.$v.model.codeUser.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.codeUser, "$model", $$v)},expression:"$v.model.codeUser.$model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Contraseña inicial","type":"password","error":_vm.$v.model.password.$error},model:{value:(_vm.$v.model.password.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.password, "$model", $$v)},expression:"$v.model.password.$model"}})],1)]:_vm._e()],2)],1),_vm._v(" "),_c('v-flex',{staticClass:"company-form-column company-settings-column",attrs:{"xs12":"","md4":"","px-3":"","pt-4":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"company-form-section-title",attrs:{"xs12":""}},[_c('label',[_vm._v("CONFIGURACIÓN GENERAL")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),(_vm.flagCompanyParent)?_c('v-flex',{attrs:{"xs12":"","mb-1":""}},[_c('v-select',{attrs:{"background-color":"white","box":"","hide-details":"","item-text":"nombreComercial","item-value":"id","label":"Compañía maestra","items":_vm.masterCompanies},model:{value:(_vm.model.companyParentId),callback:function ($$v) {_vm.$set(_vm.model, "companyParentId", $$v)},expression:"model.companyParentId"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-1":""}},[_c('v-select',{staticClass:"body-1 mt-2",attrs:{"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"id","label":"Template","items":_vm.listTemplate,"error":_vm.$v.model.idTemplate.$error},on:{"change":_vm.loadPlans},model:{value:(_vm.$v.model.idTemplate.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.idTemplate, "$model", $$v)},expression:"$v.model.idTemplate.$model"}})],1),_vm._v(" "),(_vm.plans)?_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-select',{staticClass:"body-1 mt-2",attrs:{"box":"","background-color":"white","hide-details":"","item-text":"name","item-value":"id","label":"Planes","items":_vm.plans,"return-object":""},on:{"change":_vm.onPlanChange},model:{value:(_vm.model.plans),callback:function ($$v) {_vm.$set(_vm.model, "plans", $$v)},expression:"model.plans"}})],1):_vm._e(),_vm._v(" "),(_vm.mode === 'edit' && _vm.companyPlanSectionVisible)?_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('section',{staticClass:"company-plan-limits",class:{ active: _vm.companyPlanCustomized }},[_c('div',{staticClass:"company-plan-renewal-header"},[_c('div',{staticClass:"company-plan-renewal-icon"},[_c('v-icon',[_vm._v("tune")])],1),_vm._v(" "),_c('div',{staticClass:"company-plan-renewal-copy"},[_c('strong',[_vm._v("Plan de esta compañía")]),_vm._v(" "),_c('small',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\tAjusta los límites y funciones del plan solo para\n\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.model.nombreComercial || 'esta compañía')+".\n\t\t\t\t\t\t\t\t\t\t")])]),_vm._v(" "),(_vm.companyPlanCustomized)?_c('button',{staticClass:"company-plan-limits-reset",attrs:{"type":"button"},on:{"click":_vm.resetCompanyPlan}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("restore")]),_vm._v("\n\t\t\t\t\t\t\t\t\t\tUsar valores del plan\n\t\t\t\t\t\t\t\t\t")],1):_vm._e()]),_vm._v(" "),(_vm.planHasSubsidiariesLimit)?_c('div',{staticClass:"company-plan-limits-grid"},_vm._l((_vm.companyPlanFields),function(field){return _c('label',{key:field.key,staticClass:"company-plan-limits-field",class:{ changed: _vm.isPlanFieldChanged(field.key) }},[_c('span',[_vm._v(_vm._s(field.label))]),_vm._v(" "),_c('input',{attrs:{"type":"number","min":"0"},domProps:{"value":_vm.companyPlan[field.key]},on:{"input":function($event){return _vm.setPlanField(field.key, $event.target.value)}}})])}),0):_vm._e(),_vm._v(" "),(_vm.planHasAdditionalServices)?_c('div',{staticClass:"company-plan-features"},[_c('div',{staticClass:"company-plan-features-header"},[_c('span',[_c('v-icon',[_vm._v("extension")])],1),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Otras funciones del plan")]),_vm._v(" "),_c('small',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tActiva o desactiva lo que incluye el plan solo para esta compañía.\n\t\t\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"plan-services-grid"},_vm._l((_vm.companyPlanServiceFields),function(service){return _c('button',{key:service.key,staticClass:"plan-service-card",class:{
												'plan-service-card-active': _vm.companyPlanServices[service.key],
												'plan-service-card-changed': _vm.isPlanServiceChanged(service.key)
											},attrs:{"type":"button","aria-pressed":Boolean(_vm.companyPlanServices[service.key])},on:{"click":function($event){return _vm.toggleCompanyPlanService(service.key)}}},[_c('span',{staticClass:"plan-service-icon"},[_c('v-icon',[_vm._v(_vm._s(service.icon))])],1),_vm._v(" "),_c('span',{staticClass:"plan-service-copy"},[_c('strong',[_vm._v(_vm._s(service.label))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(service.description))])]),_vm._v(" "),_c('span',{staticClass:"plan-service-action"},[_c('v-icon',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(_vm.companyPlanServices[service.key] ? 'check' : 'add')+"\n\t\t\t\t\t\t\t\t\t\t\t\t")])],1)])}),0)]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.mode === 'edit' && _vm.model.plans)?_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('section',{staticClass:"company-plan-renewal",class:{ active: _vm.renewPlan }},[_c('div',{staticClass:"company-plan-renewal-header"},[_c('div',{staticClass:"company-plan-renewal-icon"},[_c('v-icon',[_vm._v("autorenew")])],1),_vm._v(" "),_c('div',{staticClass:"company-plan-renewal-copy"},[_c('strong',[_vm._v("Renovación del plan")]),_vm._v(" "),_c('small',[_vm._v("Actívala y elige cuánto tiempo tendrá la nueva vigencia.")])]),_vm._v(" "),_c('v-checkbox',{staticClass:"company-plan-renewal-control",attrs:{"aria-label":"Renovación del plan","color":"base","hide-details":""},model:{value:(_vm.renewPlan),callback:function ($$v) {_vm.renewPlan=$$v},expression:"renewPlan"}})],1),_vm._v(" "),(!_vm.renewPlan)?_c('div',{staticClass:"company-plan-expiration"},[_c('v-icon',[_vm._v("event")]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Fecha de caducidad actual")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.currentPlanEndDate))])])],1):_vm._e(),_vm._v(" "),(_vm.renewPlan)?_c('div',{staticClass:"company-plan-renewal-period"},[_c('v-text-field',{attrs:{"background-color":"white","box":"","hide-details":"","label":"Cantidad","min":"1","type":"number"},model:{value:(_vm.renewalAmount),callback:function ($$v) {_vm.renewalAmount=_vm._n($$v)},expression:"renewalAmount"}}),_vm._v(" "),_c('v-select',{attrs:{"background-color":"white","box":"","hide-details":"","label":"Periodo","items":_vm.renewalUnits},model:{value:(_vm.renewalUnit),callback:function ($$v) {_vm.renewalUnit=$$v},expression:"renewalUnit"}})],1):_vm._e(),_vm._v(" "),(_vm.renewPlan)?_c('div',{staticClass:"company-plan-renewal-dates"},[_c('div',[_c('span',[_vm._v("Inicia")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.renewalStartDate))])]),_vm._v(" "),_c('v-icon',[_vm._v("arrow_forward")]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Finaliza")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.renewalEndDate))])])],1):_vm._e()])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","item-text":"name","item-value":"id","label":"Distribuidores","items":_vm.listDistributors},model:{value:(_vm.model.idDistributor),callback:function ($$v) {_vm.$set(_vm.model, "idDistributor", $$v)},expression:"model.idDistributor"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pr-2":"","mb-2":""}},[_c('v-select',{staticClass:"body-1",attrs:{"box":"","background-color":"white","hide-details":"","label":"País","item-text":"name","item-value":"id","items":_vm.countries,"error":_vm.$v.model.countryId.$error},model:{value:(_vm.$v.model.countryId.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.countryId, "$model", $$v)},expression:"$v.model.countryId.$model"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"company-languages-section",attrs:{"xs12":""}},[_c('div',{staticClass:"company-languages-header"},[_c('div',[_c('label',[_vm._v("IDIOMAS")]),_vm._v(" "),_c('small',[_vm._v("Selecciona al menos un idioma para la compañía.")])]),_vm._v(" "),_c('span',[_vm._v("Obligatorio")])]),_vm._v(" "),(_vm.hasLanguages)?_c('v-layout',{staticClass:"company-language-options",attrs:{"row":"","wrap":""}},_vm._l((_vm.languagesByProject),function(language,key){return _c('v-flex',{key:key,staticClass:"company-language-option",attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"color":"success","hide-details":"","label":language.name || language.id || key},on:{"change":function($event){return _vm.selectLanguages(language, key)}},model:{value:(language.isSelected),callback:function ($$v) {_vm.$set(language, "isSelected", $$v)},expression:"language.isSelected"}})],1)}),1):_c('div',{staticClass:"company-languages-empty"},[_c('v-icon',[_vm._v("language")]),_vm._v(" "),_c('span',[_vm._v("Este proyecto no tiene idiomas disponibles.")])],1),_vm._v(" "),(_vm.languageSelectionInvalid && _vm.hasLanguages)?_c('small',{staticClass:"company-languages-error"},[_vm._v("\n\t\t\t\t\t\t\t\tDebes seleccionar al menos un idioma.\n\t\t\t\t\t\t\t")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"color":"success","label":"Franquicia"},model:{value:(_vm.flagFranchises),callback:function ($$v) {_vm.flagFranchises=$$v},expression:"flagFranchises"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"color":"success","label":"Kardex"},model:{value:(_vm.flagKardex),callback:function ($$v) {_vm.flagKardex=$$v},expression:"flagKardex"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"color":"success","label":"Restringir accesos web services"},model:{value:(_vm.model.flagAllowAccess),callback:function ($$v) {_vm.$set(_vm.model, "flagAllowAccess", $$v)},expression:"model.flagAllowAccess"}})],1),_vm._v(" "),(_vm.flagKardex === true)?_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Cantidad de Recalculos Kardex","required":"","type":"number"},model:{value:(_vm.recalculateKardex),callback:function ($$v) {_vm.recalculateKardex=$$v},expression:"recalculateKardex"}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"title-form pl-2"},[_vm._v("INTEGRAR APLICACIONES")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_vm._l((_vm.model.settings.serviceExternal),function(item,index){return _c('v-flex',{key:index,attrs:{"mb-2":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{staticClass:"mt-0",attrs:{"color":"base","hide-details":""},on:{"change":function($event){return _vm.changeState(index)}},model:{value:(item.flagSelected),callback:function ($$v) {_vm.$set(item, "flagSelected", $$v)},expression:"item.flagSelected"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"title-validations",attrs:{"xs10":""}},[_vm._v("\n\t\t\t\t\t\t\t\t\t"+_vm._s(item.title)+"\n\t\t\t\t\t\t\t\t")])],1),_vm._v(" "),(item.open)?_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('label',{ref:("json-" + index),refInFor:true,attrs:{"for":("json-id-" + index)}},[_c('vue-six-four',{attrs:{"id":("json-id-" + index),"hidden":""},on:{"vue-six-four":function($event){return _vm.getFile($event, index)}}}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-text-field',{staticClass:"body-1 mb-3",attrs:{"box":"","label":"Credencial","background-color":"white","hide-details":"","readonly":""},model:{value:(item.credential),callback:function ($$v) {_vm.$set(item, "credential", $$v)},expression:"item.credential"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","text-xs-left":"","mt-3":""}},[_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"base"},on:{"click":function($event){return _vm.showDialog(("json-" + index))}}},[_vm._v("Adjuntar Archivo")])],1)],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"body-1 mb-3",attrs:{"box":"","label":"URL","background-color":"white","hide-details":""},model:{value:(item.databaseURL),callback:function ($$v) {_vm.$set(item, "databaseURL", $$v)},expression:"item.databaseURL"}})],1)],1):_vm._e()],1)})],2)],1),_vm._v(" "),_c('v-flex',{staticClass:"company-form-column company-modules-column",attrs:{"xs12":"","md4":"","pr-4":"","pl-3":"","pt-4":""}},[(_vm.mode === 'create' && _vm.model.idTemplate)?_c('div',{staticClass:"template-modules-info"},[_c('v-icon',[_vm._v("account_tree")]),_vm._v(" "),_c('div',[_c('strong',[_vm._v("Configuración administrada por el template")]),_vm._v(" "),_c('p',[_vm._v("Las aplicaciones, módulos, roles y recursos se crearán usando el template seleccionado.")])])],1):[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"title-form pl-2"},[_vm._v("LISTA DE MÓDULOS")]),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('label',{staticClass:"title-form pl-2"},[_vm._v("Selecciona los módulos para tu compañía")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","items":_vm.apps,"item-text":"name","item-value":"codeApp","label":"Aplicaciones"},on:{"input":_vm.loadModules},model:{value:(_vm.codeApp),callback:function ($$v) {_vm.codeApp=$$v},expression:"codeApp"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"company-modules-list"},_vm._l((_vm.modules),function(module,moduleIndex){return _c('section',{key:module.id || module.codeModule || moduleIndex,staticClass:"module-config-item",class:{ 'is-selected': module.isSelected }},[_c('header',{staticClass:"module-config-header"},[_c('div',{staticClass:"module-config-check"},[_c('v-checkbox',{staticClass:"mt-0",attrs:{"color":"success","hide-details":"","disabled":_vm.expandDisabled,"label":module.name},on:{"change":function($event){return _vm.removeModelModule(module, moduleIndex)}},model:{value:(module.isSelected),callback:function ($$v) {_vm.$set(module, "isSelected", $$v)},expression:"module.isSelected"}})],1),_vm._v(" "),(module.isSelected)?_c('button',{attrs:{"type":"button","title":"Configurar módulo"},on:{"click":function($event){return _vm.toggleModule(moduleIndex)}}},[_c('span',[_vm._v("Configurar")]),_c('v-icon',[_vm._v("chevron_right")])],1):_vm._e()])])}),0)]],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"610","content-class":"module-config-dialog"},model:{value:(_vm.moduleConfigDialog),callback:function ($$v) {_vm.moduleConfigDialog=$$v},expression:"moduleConfigDialog"}},[(_vm.selectedModuleConfig)?_c('v-card',{staticClass:"module-config-card"},[_c('header',{staticClass:"module-config-dialog-header"},[_c('div',[_c('small',[_vm._v("CONFIGURACIÓN DEL MÓDULO")]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.selectedModuleConfig.name))]),_vm._v(" "),_c('p',[_vm._v("Personaliza el nombre, la posición y el icono.")])]),_vm._v(" "),_c('button',{attrs:{"type":"button","title":"Cerrar"},on:{"click":_vm.closeModuleConfig}},[_c('v-icon',[_vm._v("close")])],1)]),_vm._v(" "),_c('v-card-text',{staticClass:"module-config-content"},[_vm._l((_vm.selectedModuleConfig.languages),function(language,key){return _c('v-layout',{key:key,attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs2":"","text-xs-right":""}},[_c('label',[_vm._v(_vm._s(language.id))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Nombre","required":""},model:{value:(language.name),callback:function ($$v) {_vm.$set(language, "name", $$v)},expression:"language.name"}})],1)],1)}),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","align-center":"","px-5":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('label',[_vm._v("Posición")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","pr-4":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","type":"number","min":"1","label":"Posición"},on:{"input":function($event){return _vm.setPosition(_vm.selectedModuleConfig)}},model:{value:(_vm.selectedModuleConfig.position),callback:function ($$v) {_vm.$set(_vm.selectedModuleConfig, "position", _vm._n($$v))},expression:"selectedModuleConfig.position"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","pr-0":""}},[_c('upload-image',{attrs:{"label-ref":((_vm.selectedModuleConfig.id) + "-up"),"label-for":((_vm.selectedModuleConfig.id) + "-image"),"input-id":((_vm.selectedModuleConfig.id) + "-image"),"item-update":_vm.selectedModuleConfig},on:{"send-image":_vm.sendImage}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"solo":"","hide-details":"","readonly":"","label":"Icono"},model:{value:(_vm.selectedModuleConfig.pathIcon),callback:function ($$v) {_vm.$set(_vm.selectedModuleConfig, "pathIcon", $$v)},expression:"selectedModuleConfig.pathIcon"}})],1)],1)],2),_vm._v(" "),_c('v-card-actions',{staticClass:"module-config-dialog-actions"},[_c('v-btn',{attrs:{"type":"button","color":"base","dark":""},on:{"click":_vm.closeModuleConfig}},[_vm._v("Listo "),_c('v-icon',{attrs:{"right":""}},[_vm._v("check")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.$v.$invalid || _vm.loading,"on-run-service":_vm.loading,"success-text":"Grabar"},on:{"accept-button-clicked":_vm.submitForm,"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header-page',{attrs:{"name":"companies-new","title":_vm.$route.meta.title}}),_vm._v(" "),_c('company-form',{attrs:{"code-company":_vm.codeCompany,"company-id":_vm.idCompany,"code-project":_vm.codeProject}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]));


// WEBPACK FOOTER //
// static/js/1.df554d34804c4f3d7de0.js